/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UnauthorizedImport } from './routes/unauthorized'
import { Route as LoginImport } from './routes/login'
import { Route as ConfirmEmailImport } from './routes/confirm-email'
import { Route as IndexImport } from './routes/index'
import { Route as TutordashboardLayoutImport } from './routes/tutordashboard/_layout'
import { Route as TutorTutorIdImport } from './routes/tutor.$tutorId'
import { Route as ClientdashboardLayoutImport } from './routes/clientdashboard/_layout'
import { Route as ClassesSignUpConfirmedImport } from './routes/classes/sign-up-confirmed'
import { Route as AdmindashboardLayoutImport } from './routes/admindashboard/_layout'
import { Route as AdmindashboardLayoutIndexImport } from './routes/admindashboard/_layout/index'
import { Route as ClientdashboardLayoutCheckoutImport } from './routes/clientdashboard/_layout/checkout'
import { Route as AdmindashboardLayoutTransactionsImport } from './routes/admindashboard/_layout/transactions'
import { Route as AdmindashboardLayoutKpiImport } from './routes/admindashboard/_layout/kpi'
import { Route as AdmindashboardLayoutEventsImport } from './routes/admindashboard/_layout/events'
import { Route as AdmindashboardLayoutClassesImport } from './routes/admindashboard/_layout/classes'
import { Route as ClientdashboardLayoutStripeCheckoutImport } from './routes/clientdashboard/_layout/stripe.checkout'

// Create Virtual Routes

const TutordashboardImport = createFileRoute('/tutordashboard')()
const ClientdashboardImport = createFileRoute('/clientdashboard')()
const AdmindashboardImport = createFileRoute('/admindashboard')()
const UpdatePasswordLazyImport = createFileRoute('/update-password')()
const TutorsLazyImport = createFileRoute('/tutors')()
const TermsLazyImport = createFileRoute('/terms')()
const SubjectsLazyImport = createFileRoute('/subjects')()
const SignUpLazyImport = createFileRoute('/sign-up')()
const NotificationsLazyImport = createFileRoute('/notifications')()
const HowToGuidesLazyImport = createFileRoute('/how-to-guides')()
const ForgotPasswordLazyImport = createFileRoute('/forgot-password')()
const FeedbackFormLazyImport = createFileRoute('/feedback-form')()
const FeedbackLazyImport = createFileRoute('/feedback')()
const ContactLazyImport = createFileRoute('/contact')()
const ApplyLazyImport = createFileRoute('/apply')()
const AboutLazyImport = createFileRoute('/about')()
const CollegeAdvisingIndexLazyImport = createFileRoute('/college-advising/')()
const ClassesIndexLazyImport = createFileRoute('/classes/')()
const CollegeAdvisingBookAWorkshopLazyImport = createFileRoute(
  '/college-advising/book-a-workshop',
)()
const ClassesBrowseLazyImport = createFileRoute('/classes/browse')()
const TutordashboardLayoutIndexLazyImport = createFileRoute(
  '/tutordashboard/_layout/',
)()
const ClientdashboardLayoutIndexLazyImport = createFileRoute(
  '/clientdashboard/_layout/',
)()
const TutordashboardLayoutProfileLazyImport = createFileRoute(
  '/tutordashboard/_layout/profile',
)()
const TutordashboardLayoutInquiriesLazyImport = createFileRoute(
  '/tutordashboard/_layout/inquiries',
)()
const TutordashboardLayoutEventsLazyImport = createFileRoute(
  '/tutordashboard/_layout/events',
)()
const TutordashboardLayoutCreateEventLazyImport = createFileRoute(
  '/tutordashboard/_layout/create-event',
)()
const TutordashboardLayoutCreateBookingLazyImport = createFileRoute(
  '/tutordashboard/_layout/create-booking',
)()
const TutordashboardLayoutClientsLazyImport = createFileRoute(
  '/tutordashboard/_layout/clients',
)()
const ClientdashboardLayoutOnboardLazyImport = createFileRoute(
  '/clientdashboard/_layout/onboard',
)()
const ClientdashboardLayoutEventsLazyImport = createFileRoute(
  '/clientdashboard/_layout/events',
)()
const ClientdashboardLayoutEngagementagreementLazyImport = createFileRoute(
  '/clientdashboard/_layout/engagement_agreement',
)()
const AdmindashboardLayoutUsersLazyImport = createFileRoute(
  '/admindashboard/_layout/users',
)()
const AdmindashboardLayoutTutorFeedbackLazyImport = createFileRoute(
  '/admindashboard/_layout/tutor-feedback',
)()
const AdmindashboardLayoutTutorApplicationsLazyImport = createFileRoute(
  '/admindashboard/_layout/tutor-applications',
)()
const AdmindashboardLayoutSubjectsLazyImport = createFileRoute(
  '/admindashboard/_layout/subjects',
)()
const AdmindashboardLayoutStaffLazyImport = createFileRoute(
  '/admindashboard/_layout/staff',
)()
const AdmindashboardLayoutMessagingLazyImport = createFileRoute(
  '/admindashboard/_layout/messaging',
)()
const AdmindashboardLayoutInquiriesLazyImport = createFileRoute(
  '/admindashboard/_layout/inquiries',
)()
const AdmindashboardLayoutFilesLazyImport = createFileRoute(
  '/admindashboard/_layout/files',
)()
const AdmindashboardLayoutFamiliesLazyImport = createFileRoute(
  '/admindashboard/_layout/families',
)()
const AdmindashboardLayoutConfigurationsLazyImport = createFileRoute(
  '/admindashboard/_layout/configurations',
)()
const AdmindashboardLayoutAnalyticsLazyImport = createFileRoute(
  '/admindashboard/_layout/analytics',
)()
const TutordashboardLayoutInquiriesIdLazyImport = createFileRoute(
  '/tutordashboard/_layout/inquiries_/$id',
)()
const TutordashboardLayoutEventsEventIdLazyImport = createFileRoute(
  '/tutordashboard/_layout/events_/$eventId',
)()
const ClientdashboardLayoutStripeSuccessLazyImport = createFileRoute(
  '/clientdashboard/_layout/stripe/success',
)()
const ClientdashboardLayoutStripeCancelLazyImport = createFileRoute(
  '/clientdashboard/_layout/stripe/cancel',
)()
const ClientdashboardLayoutEventEventIdLazyImport = createFileRoute(
  '/clientdashboard/_layout/event/$eventId',
)()
const AdmindashboardLayoutUsersUserIdLazyImport = createFileRoute(
  '/admindashboard/_layout/users_/$userId',
)()
const AdmindashboardLayoutTransactionsTransactionIdLazyImport = createFileRoute(
  '/admindashboard/_layout/transactions_/$transactionId',
)()
const AdmindashboardLayoutStaffCreateLazyImport = createFileRoute(
  '/admindashboard/_layout/staff_/create',
)()
const AdmindashboardLayoutStaffStaffIdLazyImport = createFileRoute(
  '/admindashboard/_layout/staff_/$staffId',
)()
const AdmindashboardLayoutMessagingNewLazyImport = createFileRoute(
  '/admindashboard/_layout/messaging_/new',
)()
const AdmindashboardLayoutInquiriesIdLazyImport = createFileRoute(
  '/admindashboard/_layout/inquiries_/$id',
)()
const AdmindashboardLayoutFamilyFamilyIdLazyImport = createFileRoute(
  '/admindashboard/_layout/family/$familyId',
)()
const AdmindashboardLayoutEventsNewLazyImport = createFileRoute(
  '/admindashboard/_layout/events_/new',
)()
const AdmindashboardLayoutEventsEventIdLazyImport = createFileRoute(
  '/admindashboard/_layout/events_/$eventId',
)()
const AdmindashboardLayoutClassesNewLazyImport = createFileRoute(
  '/admindashboard/_layout/classes_/new',
)()
const AdmindashboardLayoutClassesClassIdLazyImport = createFileRoute(
  '/admindashboard/_layout/classes_/$classId',
)()
const AdmindashboardLayoutUsersUserIdEditLazyImport = createFileRoute(
  '/admindashboard/_layout/users_/$userId_/edit',
)()
const AdmindashboardLayoutTransactionsTransactionIdEditLazyImport =
  createFileRoute(
    '/admindashboard/_layout/transactions_/$transactionId_/edit',
  )()
const AdmindashboardLayoutStaffStaffIdEditLazyImport = createFileRoute(
  '/admindashboard/_layout/staff_/$staffId_/edit',
)()
const AdmindashboardLayoutMessagingRuleIdEditLazyImport = createFileRoute(
  '/admindashboard/_layout/messaging_/$ruleId/edit',
)()
const AdmindashboardLayoutInquiriesIdEditLazyImport = createFileRoute(
  '/admindashboard/_layout/inquiries_/$id_/edit',
)()
const AdmindashboardLayoutFamilyFamilyIdEditLazyImport = createFileRoute(
  '/admindashboard/_layout/family/$familyId_/edit',
)()
const AdmindashboardLayoutEventsEventIdEditLazyImport = createFileRoute(
  '/admindashboard/_layout/events_/$eventId_/edit',
)()
const AdmindashboardLayoutEventsEventIdChargeLazyImport = createFileRoute(
  '/admindashboard/_layout/events_/$eventId_/charge',
)()
const AdmindashboardLayoutClassesClassIdEditLazyImport = createFileRoute(
  '/admindashboard/_layout/classes_/$classId_/edit',
)()

// Create/Update Routes

const TutordashboardRoute = TutordashboardImport.update({
  id: '/tutordashboard',
  path: '/tutordashboard',
  getParentRoute: () => rootRoute,
} as any)

const ClientdashboardRoute = ClientdashboardImport.update({
  id: '/clientdashboard',
  path: '/clientdashboard',
  getParentRoute: () => rootRoute,
} as any)

const AdmindashboardRoute = AdmindashboardImport.update({
  id: '/admindashboard',
  path: '/admindashboard',
  getParentRoute: () => rootRoute,
} as any)

const UpdatePasswordLazyRoute = UpdatePasswordLazyImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/update-password.lazy').then((d) => d.Route),
)

const TutorsLazyRoute = TutorsLazyImport.update({
  id: '/tutors',
  path: '/tutors',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/tutors.lazy').then((d) => d.Route))

const TermsLazyRoute = TermsLazyImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/terms.lazy').then((d) => d.Route))

const SubjectsLazyRoute = SubjectsLazyImport.update({
  id: '/subjects',
  path: '/subjects',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/subjects.lazy').then((d) => d.Route))

const SignUpLazyRoute = SignUpLazyImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/sign-up.lazy').then((d) => d.Route))

const NotificationsLazyRoute = NotificationsLazyImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/notifications.lazy').then((d) => d.Route))

const HowToGuidesLazyRoute = HowToGuidesLazyImport.update({
  id: '/how-to-guides',
  path: '/how-to-guides',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/how-to-guides.lazy').then((d) => d.Route))

const ForgotPasswordLazyRoute = ForgotPasswordLazyImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/forgot-password.lazy').then((d) => d.Route),
)

const FeedbackFormLazyRoute = FeedbackFormLazyImport.update({
  id: '/feedback-form',
  path: '/feedback-form',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/feedback-form.lazy').then((d) => d.Route))

const FeedbackLazyRoute = FeedbackLazyImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/feedback.lazy').then((d) => d.Route))

const ContactLazyRoute = ContactLazyImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/contact.lazy').then((d) => d.Route))

const ApplyLazyRoute = ApplyLazyImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/apply.lazy').then((d) => d.Route))

const AboutLazyRoute = AboutLazyImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const UnauthorizedRoute = UnauthorizedImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ConfirmEmailRoute = ConfirmEmailImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const CollegeAdvisingIndexLazyRoute = CollegeAdvisingIndexLazyImport.update({
  id: '/college-advising/',
  path: '/college-advising/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/college-advising/index.lazy').then((d) => d.Route),
)

const ClassesIndexLazyRoute = ClassesIndexLazyImport.update({
  id: '/classes/',
  path: '/classes/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/classes/index.lazy').then((d) => d.Route))

const CollegeAdvisingBookAWorkshopLazyRoute =
  CollegeAdvisingBookAWorkshopLazyImport.update({
    id: '/college-advising/book-a-workshop',
    path: '/college-advising/book-a-workshop',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/college-advising/book-a-workshop.lazy').then(
      (d) => d.Route,
    ),
  )

const ClassesBrowseLazyRoute = ClassesBrowseLazyImport.update({
  id: '/classes/browse',
  path: '/classes/browse',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/classes/browse.lazy').then((d) => d.Route),
)

const TutordashboardLayoutRoute = TutordashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => TutordashboardRoute,
} as any)

const TutorTutorIdRoute = TutorTutorIdImport.update({
  id: '/tutor/$tutorId',
  path: '/tutor/$tutorId',
  getParentRoute: () => rootRoute,
} as any)

const ClientdashboardLayoutRoute = ClientdashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => ClientdashboardRoute,
} as any)

const ClassesSignUpConfirmedRoute = ClassesSignUpConfirmedImport.update({
  id: '/classes/sign-up-confirmed',
  path: '/classes/sign-up-confirmed',
  getParentRoute: () => rootRoute,
} as any)

const AdmindashboardLayoutRoute = AdmindashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AdmindashboardRoute,
} as any)

const TutordashboardLayoutIndexLazyRoute =
  TutordashboardLayoutIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/index.lazy').then((d) => d.Route),
  )

const ClientdashboardLayoutIndexLazyRoute =
  ClientdashboardLayoutIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/index.lazy').then((d) => d.Route),
  )

const AdmindashboardLayoutIndexRoute = AdmindashboardLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdmindashboardLayoutRoute,
} as any).lazy(() =>
  import('./routes/admindashboard/_layout/index.lazy').then((d) => d.Route),
)

const TutordashboardLayoutProfileLazyRoute =
  TutordashboardLayoutProfileLazyImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/profile.lazy').then((d) => d.Route),
  )

const TutordashboardLayoutInquiriesLazyRoute =
  TutordashboardLayoutInquiriesLazyImport.update({
    id: '/inquiries',
    path: '/inquiries',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/inquiries.lazy').then(
      (d) => d.Route,
    ),
  )

const TutordashboardLayoutEventsLazyRoute =
  TutordashboardLayoutEventsLazyImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/events.lazy').then((d) => d.Route),
  )

const TutordashboardLayoutCreateEventLazyRoute =
  TutordashboardLayoutCreateEventLazyImport.update({
    id: '/create-event',
    path: '/create-event',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/create-event.lazy').then(
      (d) => d.Route,
    ),
  )

const TutordashboardLayoutCreateBookingLazyRoute =
  TutordashboardLayoutCreateBookingLazyImport.update({
    id: '/create-booking',
    path: '/create-booking',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/create-booking.lazy').then(
      (d) => d.Route,
    ),
  )

const TutordashboardLayoutClientsLazyRoute =
  TutordashboardLayoutClientsLazyImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/clients.lazy').then((d) => d.Route),
  )

const ClientdashboardLayoutOnboardLazyRoute =
  ClientdashboardLayoutOnboardLazyImport.update({
    id: '/onboard',
    path: '/onboard',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/onboard.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientdashboardLayoutEventsLazyRoute =
  ClientdashboardLayoutEventsLazyImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/events.lazy').then((d) => d.Route),
  )

const ClientdashboardLayoutEngagementagreementLazyRoute =
  ClientdashboardLayoutEngagementagreementLazyImport.update({
    id: '/engagement_agreement',
    path: '/engagement_agreement',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/engagement_agreement.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutUsersLazyRoute =
  AdmindashboardLayoutUsersLazyImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/users.lazy').then((d) => d.Route),
  )

const AdmindashboardLayoutTutorFeedbackLazyRoute =
  AdmindashboardLayoutTutorFeedbackLazyImport.update({
    id: '/tutor-feedback',
    path: '/tutor-feedback',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/tutor-feedback.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutTutorApplicationsLazyRoute =
  AdmindashboardLayoutTutorApplicationsLazyImport.update({
    id: '/tutor-applications',
    path: '/tutor-applications',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/tutor-applications.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutSubjectsLazyRoute =
  AdmindashboardLayoutSubjectsLazyImport.update({
    id: '/subjects',
    path: '/subjects',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/subjects.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutStaffLazyRoute =
  AdmindashboardLayoutStaffLazyImport.update({
    id: '/staff',
    path: '/staff',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/staff.lazy').then((d) => d.Route),
  )

const AdmindashboardLayoutMessagingLazyRoute =
  AdmindashboardLayoutMessagingLazyImport.update({
    id: '/messaging',
    path: '/messaging',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/messaging.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutInquiriesLazyRoute =
  AdmindashboardLayoutInquiriesLazyImport.update({
    id: '/inquiries',
    path: '/inquiries',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/inquiries.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutFilesLazyRoute =
  AdmindashboardLayoutFilesLazyImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/files.lazy').then((d) => d.Route),
  )

const AdmindashboardLayoutFamiliesLazyRoute =
  AdmindashboardLayoutFamiliesLazyImport.update({
    id: '/families',
    path: '/families',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/families.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutConfigurationsLazyRoute =
  AdmindashboardLayoutConfigurationsLazyImport.update({
    id: '/configurations',
    path: '/configurations',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/configurations.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutAnalyticsLazyRoute =
  AdmindashboardLayoutAnalyticsLazyImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/analytics.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientdashboardLayoutCheckoutRoute =
  ClientdashboardLayoutCheckoutImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/checkout.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutTransactionsRoute =
  AdmindashboardLayoutTransactionsImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/transactions.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutKpiRoute = AdmindashboardLayoutKpiImport.update({
  id: '/kpi',
  path: '/kpi',
  getParentRoute: () => AdmindashboardLayoutRoute,
} as any).lazy(() =>
  import('./routes/admindashboard/_layout/kpi.lazy').then((d) => d.Route),
)

const AdmindashboardLayoutEventsRoute = AdmindashboardLayoutEventsImport.update(
  {
    id: '/events',
    path: '/events',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any,
).lazy(() =>
  import('./routes/admindashboard/_layout/events.lazy').then((d) => d.Route),
)

const AdmindashboardLayoutClassesRoute =
  AdmindashboardLayoutClassesImport.update({
    id: '/classes',
    path: '/classes',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/classes.lazy').then((d) => d.Route),
  )

const TutordashboardLayoutInquiriesIdLazyRoute =
  TutordashboardLayoutInquiriesIdLazyImport.update({
    id: '/inquiries_/$id',
    path: '/inquiries/$id',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/inquiries_.$id.lazy').then(
      (d) => d.Route,
    ),
  )

const TutordashboardLayoutEventsEventIdLazyRoute =
  TutordashboardLayoutEventsEventIdLazyImport.update({
    id: '/events_/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => TutordashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/tutordashboard/_layout/events_.$eventId.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientdashboardLayoutStripeSuccessLazyRoute =
  ClientdashboardLayoutStripeSuccessLazyImport.update({
    id: '/stripe/success',
    path: '/stripe/success',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/stripe.success.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientdashboardLayoutStripeCancelLazyRoute =
  ClientdashboardLayoutStripeCancelLazyImport.update({
    id: '/stripe/cancel',
    path: '/stripe/cancel',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/stripe.cancel.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientdashboardLayoutEventEventIdLazyRoute =
  ClientdashboardLayoutEventEventIdLazyImport.update({
    id: '/event/$eventId',
    path: '/event/$eventId',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/event.$eventId.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutUsersUserIdLazyRoute =
  AdmindashboardLayoutUsersUserIdLazyImport.update({
    id: '/users_/$userId',
    path: '/users/$userId',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/users_.$userId.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutTransactionsTransactionIdLazyRoute =
  AdmindashboardLayoutTransactionsTransactionIdLazyImport.update({
    id: '/transactions_/$transactionId',
    path: '/transactions/$transactionId',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/admindashboard/_layout/transactions_.$transactionId.lazy'
    ).then((d) => d.Route),
  )

const AdmindashboardLayoutStaffCreateLazyRoute =
  AdmindashboardLayoutStaffCreateLazyImport.update({
    id: '/staff_/create',
    path: '/staff/create',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/staff_.create.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutStaffStaffIdLazyRoute =
  AdmindashboardLayoutStaffStaffIdLazyImport.update({
    id: '/staff_/$staffId',
    path: '/staff/$staffId',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/staff_.$staffId.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutMessagingNewLazyRoute =
  AdmindashboardLayoutMessagingNewLazyImport.update({
    id: '/messaging_/new',
    path: '/messaging/new',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/messaging_.new.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutInquiriesIdLazyRoute =
  AdmindashboardLayoutInquiriesIdLazyImport.update({
    id: '/inquiries_/$id',
    path: '/inquiries/$id',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/inquiries_.$id.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutFamilyFamilyIdLazyRoute =
  AdmindashboardLayoutFamilyFamilyIdLazyImport.update({
    id: '/family/$familyId',
    path: '/family/$familyId',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/family.$familyId.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutEventsNewLazyRoute =
  AdmindashboardLayoutEventsNewLazyImport.update({
    id: '/events_/new',
    path: '/events/new',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/events_.new.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutEventsEventIdLazyRoute =
  AdmindashboardLayoutEventsEventIdLazyImport.update({
    id: '/events_/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/events_.$eventId.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutClassesNewLazyRoute =
  AdmindashboardLayoutClassesNewLazyImport.update({
    id: '/classes_/new',
    path: '/classes/new',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/classes_.new.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutClassesClassIdLazyRoute =
  AdmindashboardLayoutClassesClassIdLazyImport.update({
    id: '/classes_/$classId',
    path: '/classes/$classId',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/classes_.$classId.lazy').then(
      (d) => d.Route,
    ),
  )

const ClientdashboardLayoutStripeCheckoutRoute =
  ClientdashboardLayoutStripeCheckoutImport.update({
    id: '/stripe/checkout',
    path: '/stripe/checkout',
    getParentRoute: () => ClientdashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/clientdashboard/_layout/stripe.checkout.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutUsersUserIdEditLazyRoute =
  AdmindashboardLayoutUsersUserIdEditLazyImport.update({
    id: '/users_/$userId_/edit',
    path: '/users/$userId/edit',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/users_.$userId_.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutTransactionsTransactionIdEditLazyRoute =
  AdmindashboardLayoutTransactionsTransactionIdEditLazyImport.update({
    id: '/transactions_/$transactionId_/edit',
    path: '/transactions/$transactionId/edit',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/admindashboard/_layout/transactions_.$transactionId_.edit.lazy'
    ).then((d) => d.Route),
  )

const AdmindashboardLayoutStaffStaffIdEditLazyRoute =
  AdmindashboardLayoutStaffStaffIdEditLazyImport.update({
    id: '/staff_/$staffId_/edit',
    path: '/staff/$staffId/edit',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/staff_.$staffId_.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutMessagingRuleIdEditLazyRoute =
  AdmindashboardLayoutMessagingRuleIdEditLazyImport.update({
    id: '/messaging_/$ruleId/edit',
    path: '/messaging/$ruleId/edit',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/messaging_.$ruleId.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutInquiriesIdEditLazyRoute =
  AdmindashboardLayoutInquiriesIdEditLazyImport.update({
    id: '/inquiries_/$id_/edit',
    path: '/inquiries/$id/edit',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/inquiries_.$id_.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutFamilyFamilyIdEditLazyRoute =
  AdmindashboardLayoutFamilyFamilyIdEditLazyImport.update({
    id: '/family/$familyId_/edit',
    path: '/family/$familyId/edit',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/family.$familyId_.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutEventsEventIdEditLazyRoute =
  AdmindashboardLayoutEventsEventIdEditLazyImport.update({
    id: '/events_/$eventId_/edit',
    path: '/events/$eventId/edit',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/events_.$eventId_.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AdmindashboardLayoutEventsEventIdChargeLazyRoute =
  AdmindashboardLayoutEventsEventIdChargeLazyImport.update({
    id: '/events_/$eventId_/charge',
    path: '/events/$eventId/charge',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/admindashboard/_layout/events_.$eventId_.charge.lazy'
    ).then((d) => d.Route),
  )

const AdmindashboardLayoutClassesClassIdEditLazyRoute =
  AdmindashboardLayoutClassesClassIdEditLazyImport.update({
    id: '/classes_/$classId_/edit',
    path: '/classes/$classId/edit',
    getParentRoute: () => AdmindashboardLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admindashboard/_layout/classes_.$classId_.edit.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/confirm-email': {
      id: '/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof ConfirmEmailImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/apply': {
      id: '/apply'
      path: '/apply'
      fullPath: '/apply'
      preLoaderRoute: typeof ApplyLazyImport
      parentRoute: typeof rootRoute
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactLazyImport
      parentRoute: typeof rootRoute
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackLazyImport
      parentRoute: typeof rootRoute
    }
    '/feedback-form': {
      id: '/feedback-form'
      path: '/feedback-form'
      fullPath: '/feedback-form'
      preLoaderRoute: typeof FeedbackFormLazyImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordLazyImport
      parentRoute: typeof rootRoute
    }
    '/how-to-guides': {
      id: '/how-to-guides'
      path: '/how-to-guides'
      fullPath: '/how-to-guides'
      preLoaderRoute: typeof HowToGuidesLazyImport
      parentRoute: typeof rootRoute
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsLazyImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpLazyImport
      parentRoute: typeof rootRoute
    }
    '/subjects': {
      id: '/subjects'
      path: '/subjects'
      fullPath: '/subjects'
      preLoaderRoute: typeof SubjectsLazyImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsLazyImport
      parentRoute: typeof rootRoute
    }
    '/tutors': {
      id: '/tutors'
      path: '/tutors'
      fullPath: '/tutors'
      preLoaderRoute: typeof TutorsLazyImport
      parentRoute: typeof rootRoute
    }
    '/update-password': {
      id: '/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof UpdatePasswordLazyImport
      parentRoute: typeof rootRoute
    }
    '/admindashboard': {
      id: '/admindashboard'
      path: '/admindashboard'
      fullPath: '/admindashboard'
      preLoaderRoute: typeof AdmindashboardImport
      parentRoute: typeof rootRoute
    }
    '/admindashboard/_layout': {
      id: '/admindashboard/_layout'
      path: '/admindashboard'
      fullPath: '/admindashboard'
      preLoaderRoute: typeof AdmindashboardLayoutImport
      parentRoute: typeof AdmindashboardRoute
    }
    '/classes/sign-up-confirmed': {
      id: '/classes/sign-up-confirmed'
      path: '/classes/sign-up-confirmed'
      fullPath: '/classes/sign-up-confirmed'
      preLoaderRoute: typeof ClassesSignUpConfirmedImport
      parentRoute: typeof rootRoute
    }
    '/clientdashboard': {
      id: '/clientdashboard'
      path: '/clientdashboard'
      fullPath: '/clientdashboard'
      preLoaderRoute: typeof ClientdashboardImport
      parentRoute: typeof rootRoute
    }
    '/clientdashboard/_layout': {
      id: '/clientdashboard/_layout'
      path: '/clientdashboard'
      fullPath: '/clientdashboard'
      preLoaderRoute: typeof ClientdashboardLayoutImport
      parentRoute: typeof ClientdashboardRoute
    }
    '/tutor/$tutorId': {
      id: '/tutor/$tutorId'
      path: '/tutor/$tutorId'
      fullPath: '/tutor/$tutorId'
      preLoaderRoute: typeof TutorTutorIdImport
      parentRoute: typeof rootRoute
    }
    '/tutordashboard': {
      id: '/tutordashboard'
      path: '/tutordashboard'
      fullPath: '/tutordashboard'
      preLoaderRoute: typeof TutordashboardImport
      parentRoute: typeof rootRoute
    }
    '/tutordashboard/_layout': {
      id: '/tutordashboard/_layout'
      path: '/tutordashboard'
      fullPath: '/tutordashboard'
      preLoaderRoute: typeof TutordashboardLayoutImport
      parentRoute: typeof TutordashboardRoute
    }
    '/classes/browse': {
      id: '/classes/browse'
      path: '/classes/browse'
      fullPath: '/classes/browse'
      preLoaderRoute: typeof ClassesBrowseLazyImport
      parentRoute: typeof rootRoute
    }
    '/college-advising/book-a-workshop': {
      id: '/college-advising/book-a-workshop'
      path: '/college-advising/book-a-workshop'
      fullPath: '/college-advising/book-a-workshop'
      preLoaderRoute: typeof CollegeAdvisingBookAWorkshopLazyImport
      parentRoute: typeof rootRoute
    }
    '/classes/': {
      id: '/classes/'
      path: '/classes'
      fullPath: '/classes'
      preLoaderRoute: typeof ClassesIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/college-advising/': {
      id: '/college-advising/'
      path: '/college-advising'
      fullPath: '/college-advising'
      preLoaderRoute: typeof CollegeAdvisingIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/admindashboard/_layout/classes': {
      id: '/admindashboard/_layout/classes'
      path: '/classes'
      fullPath: '/admindashboard/classes'
      preLoaderRoute: typeof AdmindashboardLayoutClassesImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/events': {
      id: '/admindashboard/_layout/events'
      path: '/events'
      fullPath: '/admindashboard/events'
      preLoaderRoute: typeof AdmindashboardLayoutEventsImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/kpi': {
      id: '/admindashboard/_layout/kpi'
      path: '/kpi'
      fullPath: '/admindashboard/kpi'
      preLoaderRoute: typeof AdmindashboardLayoutKpiImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/transactions': {
      id: '/admindashboard/_layout/transactions'
      path: '/transactions'
      fullPath: '/admindashboard/transactions'
      preLoaderRoute: typeof AdmindashboardLayoutTransactionsImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/clientdashboard/_layout/checkout': {
      id: '/clientdashboard/_layout/checkout'
      path: '/checkout'
      fullPath: '/clientdashboard/checkout'
      preLoaderRoute: typeof ClientdashboardLayoutCheckoutImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/admindashboard/_layout/analytics': {
      id: '/admindashboard/_layout/analytics'
      path: '/analytics'
      fullPath: '/admindashboard/analytics'
      preLoaderRoute: typeof AdmindashboardLayoutAnalyticsLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/configurations': {
      id: '/admindashboard/_layout/configurations'
      path: '/configurations'
      fullPath: '/admindashboard/configurations'
      preLoaderRoute: typeof AdmindashboardLayoutConfigurationsLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/families': {
      id: '/admindashboard/_layout/families'
      path: '/families'
      fullPath: '/admindashboard/families'
      preLoaderRoute: typeof AdmindashboardLayoutFamiliesLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/files': {
      id: '/admindashboard/_layout/files'
      path: '/files'
      fullPath: '/admindashboard/files'
      preLoaderRoute: typeof AdmindashboardLayoutFilesLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/inquiries': {
      id: '/admindashboard/_layout/inquiries'
      path: '/inquiries'
      fullPath: '/admindashboard/inquiries'
      preLoaderRoute: typeof AdmindashboardLayoutInquiriesLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/messaging': {
      id: '/admindashboard/_layout/messaging'
      path: '/messaging'
      fullPath: '/admindashboard/messaging'
      preLoaderRoute: typeof AdmindashboardLayoutMessagingLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/staff': {
      id: '/admindashboard/_layout/staff'
      path: '/staff'
      fullPath: '/admindashboard/staff'
      preLoaderRoute: typeof AdmindashboardLayoutStaffLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/subjects': {
      id: '/admindashboard/_layout/subjects'
      path: '/subjects'
      fullPath: '/admindashboard/subjects'
      preLoaderRoute: typeof AdmindashboardLayoutSubjectsLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/tutor-applications': {
      id: '/admindashboard/_layout/tutor-applications'
      path: '/tutor-applications'
      fullPath: '/admindashboard/tutor-applications'
      preLoaderRoute: typeof AdmindashboardLayoutTutorApplicationsLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/tutor-feedback': {
      id: '/admindashboard/_layout/tutor-feedback'
      path: '/tutor-feedback'
      fullPath: '/admindashboard/tutor-feedback'
      preLoaderRoute: typeof AdmindashboardLayoutTutorFeedbackLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/users': {
      id: '/admindashboard/_layout/users'
      path: '/users'
      fullPath: '/admindashboard/users'
      preLoaderRoute: typeof AdmindashboardLayoutUsersLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/clientdashboard/_layout/engagement_agreement': {
      id: '/clientdashboard/_layout/engagement_agreement'
      path: '/engagement_agreement'
      fullPath: '/clientdashboard/engagement_agreement'
      preLoaderRoute: typeof ClientdashboardLayoutEngagementagreementLazyImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/clientdashboard/_layout/events': {
      id: '/clientdashboard/_layout/events'
      path: '/events'
      fullPath: '/clientdashboard/events'
      preLoaderRoute: typeof ClientdashboardLayoutEventsLazyImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/clientdashboard/_layout/onboard': {
      id: '/clientdashboard/_layout/onboard'
      path: '/onboard'
      fullPath: '/clientdashboard/onboard'
      preLoaderRoute: typeof ClientdashboardLayoutOnboardLazyImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/tutordashboard/_layout/clients': {
      id: '/tutordashboard/_layout/clients'
      path: '/clients'
      fullPath: '/tutordashboard/clients'
      preLoaderRoute: typeof TutordashboardLayoutClientsLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/tutordashboard/_layout/create-booking': {
      id: '/tutordashboard/_layout/create-booking'
      path: '/create-booking'
      fullPath: '/tutordashboard/create-booking'
      preLoaderRoute: typeof TutordashboardLayoutCreateBookingLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/tutordashboard/_layout/create-event': {
      id: '/tutordashboard/_layout/create-event'
      path: '/create-event'
      fullPath: '/tutordashboard/create-event'
      preLoaderRoute: typeof TutordashboardLayoutCreateEventLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/tutordashboard/_layout/events': {
      id: '/tutordashboard/_layout/events'
      path: '/events'
      fullPath: '/tutordashboard/events'
      preLoaderRoute: typeof TutordashboardLayoutEventsLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/tutordashboard/_layout/inquiries': {
      id: '/tutordashboard/_layout/inquiries'
      path: '/inquiries'
      fullPath: '/tutordashboard/inquiries'
      preLoaderRoute: typeof TutordashboardLayoutInquiriesLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/tutordashboard/_layout/profile': {
      id: '/tutordashboard/_layout/profile'
      path: '/profile'
      fullPath: '/tutordashboard/profile'
      preLoaderRoute: typeof TutordashboardLayoutProfileLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/admindashboard/_layout/': {
      id: '/admindashboard/_layout/'
      path: '/'
      fullPath: '/admindashboard/'
      preLoaderRoute: typeof AdmindashboardLayoutIndexImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/clientdashboard/_layout/': {
      id: '/clientdashboard/_layout/'
      path: '/'
      fullPath: '/clientdashboard/'
      preLoaderRoute: typeof ClientdashboardLayoutIndexLazyImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/tutordashboard/_layout/': {
      id: '/tutordashboard/_layout/'
      path: '/'
      fullPath: '/tutordashboard/'
      preLoaderRoute: typeof TutordashboardLayoutIndexLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/clientdashboard/_layout/stripe/checkout': {
      id: '/clientdashboard/_layout/stripe/checkout'
      path: '/stripe/checkout'
      fullPath: '/clientdashboard/stripe/checkout'
      preLoaderRoute: typeof ClientdashboardLayoutStripeCheckoutImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/admindashboard/_layout/classes_/$classId': {
      id: '/admindashboard/_layout/classes_/$classId'
      path: '/classes/$classId'
      fullPath: '/admindashboard/classes/$classId'
      preLoaderRoute: typeof AdmindashboardLayoutClassesClassIdLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/classes_/new': {
      id: '/admindashboard/_layout/classes_/new'
      path: '/classes/new'
      fullPath: '/admindashboard/classes/new'
      preLoaderRoute: typeof AdmindashboardLayoutClassesNewLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/events_/$eventId': {
      id: '/admindashboard/_layout/events_/$eventId'
      path: '/events/$eventId'
      fullPath: '/admindashboard/events/$eventId'
      preLoaderRoute: typeof AdmindashboardLayoutEventsEventIdLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/events_/new': {
      id: '/admindashboard/_layout/events_/new'
      path: '/events/new'
      fullPath: '/admindashboard/events/new'
      preLoaderRoute: typeof AdmindashboardLayoutEventsNewLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/family/$familyId': {
      id: '/admindashboard/_layout/family/$familyId'
      path: '/family/$familyId'
      fullPath: '/admindashboard/family/$familyId'
      preLoaderRoute: typeof AdmindashboardLayoutFamilyFamilyIdLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/inquiries_/$id': {
      id: '/admindashboard/_layout/inquiries_/$id'
      path: '/inquiries/$id'
      fullPath: '/admindashboard/inquiries/$id'
      preLoaderRoute: typeof AdmindashboardLayoutInquiriesIdLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/messaging_/new': {
      id: '/admindashboard/_layout/messaging_/new'
      path: '/messaging/new'
      fullPath: '/admindashboard/messaging/new'
      preLoaderRoute: typeof AdmindashboardLayoutMessagingNewLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/staff_/$staffId': {
      id: '/admindashboard/_layout/staff_/$staffId'
      path: '/staff/$staffId'
      fullPath: '/admindashboard/staff/$staffId'
      preLoaderRoute: typeof AdmindashboardLayoutStaffStaffIdLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/staff_/create': {
      id: '/admindashboard/_layout/staff_/create'
      path: '/staff/create'
      fullPath: '/admindashboard/staff/create'
      preLoaderRoute: typeof AdmindashboardLayoutStaffCreateLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/transactions_/$transactionId': {
      id: '/admindashboard/_layout/transactions_/$transactionId'
      path: '/transactions/$transactionId'
      fullPath: '/admindashboard/transactions/$transactionId'
      preLoaderRoute: typeof AdmindashboardLayoutTransactionsTransactionIdLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/users_/$userId': {
      id: '/admindashboard/_layout/users_/$userId'
      path: '/users/$userId'
      fullPath: '/admindashboard/users/$userId'
      preLoaderRoute: typeof AdmindashboardLayoutUsersUserIdLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/clientdashboard/_layout/event/$eventId': {
      id: '/clientdashboard/_layout/event/$eventId'
      path: '/event/$eventId'
      fullPath: '/clientdashboard/event/$eventId'
      preLoaderRoute: typeof ClientdashboardLayoutEventEventIdLazyImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/clientdashboard/_layout/stripe/cancel': {
      id: '/clientdashboard/_layout/stripe/cancel'
      path: '/stripe/cancel'
      fullPath: '/clientdashboard/stripe/cancel'
      preLoaderRoute: typeof ClientdashboardLayoutStripeCancelLazyImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/clientdashboard/_layout/stripe/success': {
      id: '/clientdashboard/_layout/stripe/success'
      path: '/stripe/success'
      fullPath: '/clientdashboard/stripe/success'
      preLoaderRoute: typeof ClientdashboardLayoutStripeSuccessLazyImport
      parentRoute: typeof ClientdashboardLayoutImport
    }
    '/tutordashboard/_layout/events_/$eventId': {
      id: '/tutordashboard/_layout/events_/$eventId'
      path: '/events/$eventId'
      fullPath: '/tutordashboard/events/$eventId'
      preLoaderRoute: typeof TutordashboardLayoutEventsEventIdLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/tutordashboard/_layout/inquiries_/$id': {
      id: '/tutordashboard/_layout/inquiries_/$id'
      path: '/inquiries/$id'
      fullPath: '/tutordashboard/inquiries/$id'
      preLoaderRoute: typeof TutordashboardLayoutInquiriesIdLazyImport
      parentRoute: typeof TutordashboardLayoutImport
    }
    '/admindashboard/_layout/classes_/$classId_/edit': {
      id: '/admindashboard/_layout/classes_/$classId_/edit'
      path: '/classes/$classId/edit'
      fullPath: '/admindashboard/classes/$classId/edit'
      preLoaderRoute: typeof AdmindashboardLayoutClassesClassIdEditLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/events_/$eventId_/charge': {
      id: '/admindashboard/_layout/events_/$eventId_/charge'
      path: '/events/$eventId/charge'
      fullPath: '/admindashboard/events/$eventId/charge'
      preLoaderRoute: typeof AdmindashboardLayoutEventsEventIdChargeLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/events_/$eventId_/edit': {
      id: '/admindashboard/_layout/events_/$eventId_/edit'
      path: '/events/$eventId/edit'
      fullPath: '/admindashboard/events/$eventId/edit'
      preLoaderRoute: typeof AdmindashboardLayoutEventsEventIdEditLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/family/$familyId_/edit': {
      id: '/admindashboard/_layout/family/$familyId_/edit'
      path: '/family/$familyId/edit'
      fullPath: '/admindashboard/family/$familyId/edit'
      preLoaderRoute: typeof AdmindashboardLayoutFamilyFamilyIdEditLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/inquiries_/$id_/edit': {
      id: '/admindashboard/_layout/inquiries_/$id_/edit'
      path: '/inquiries/$id/edit'
      fullPath: '/admindashboard/inquiries/$id/edit'
      preLoaderRoute: typeof AdmindashboardLayoutInquiriesIdEditLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/messaging_/$ruleId/edit': {
      id: '/admindashboard/_layout/messaging_/$ruleId/edit'
      path: '/messaging/$ruleId/edit'
      fullPath: '/admindashboard/messaging/$ruleId/edit'
      preLoaderRoute: typeof AdmindashboardLayoutMessagingRuleIdEditLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/staff_/$staffId_/edit': {
      id: '/admindashboard/_layout/staff_/$staffId_/edit'
      path: '/staff/$staffId/edit'
      fullPath: '/admindashboard/staff/$staffId/edit'
      preLoaderRoute: typeof AdmindashboardLayoutStaffStaffIdEditLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/transactions_/$transactionId_/edit': {
      id: '/admindashboard/_layout/transactions_/$transactionId_/edit'
      path: '/transactions/$transactionId/edit'
      fullPath: '/admindashboard/transactions/$transactionId/edit'
      preLoaderRoute: typeof AdmindashboardLayoutTransactionsTransactionIdEditLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
    '/admindashboard/_layout/users_/$userId_/edit': {
      id: '/admindashboard/_layout/users_/$userId_/edit'
      path: '/users/$userId/edit'
      fullPath: '/admindashboard/users/$userId/edit'
      preLoaderRoute: typeof AdmindashboardLayoutUsersUserIdEditLazyImport
      parentRoute: typeof AdmindashboardLayoutImport
    }
  }
}

// Create and export the route tree

interface AdmindashboardLayoutRouteChildren {
  AdmindashboardLayoutClassesRoute: typeof AdmindashboardLayoutClassesRoute
  AdmindashboardLayoutEventsRoute: typeof AdmindashboardLayoutEventsRoute
  AdmindashboardLayoutKpiRoute: typeof AdmindashboardLayoutKpiRoute
  AdmindashboardLayoutTransactionsRoute: typeof AdmindashboardLayoutTransactionsRoute
  AdmindashboardLayoutAnalyticsLazyRoute: typeof AdmindashboardLayoutAnalyticsLazyRoute
  AdmindashboardLayoutConfigurationsLazyRoute: typeof AdmindashboardLayoutConfigurationsLazyRoute
  AdmindashboardLayoutFamiliesLazyRoute: typeof AdmindashboardLayoutFamiliesLazyRoute
  AdmindashboardLayoutFilesLazyRoute: typeof AdmindashboardLayoutFilesLazyRoute
  AdmindashboardLayoutInquiriesLazyRoute: typeof AdmindashboardLayoutInquiriesLazyRoute
  AdmindashboardLayoutMessagingLazyRoute: typeof AdmindashboardLayoutMessagingLazyRoute
  AdmindashboardLayoutStaffLazyRoute: typeof AdmindashboardLayoutStaffLazyRoute
  AdmindashboardLayoutSubjectsLazyRoute: typeof AdmindashboardLayoutSubjectsLazyRoute
  AdmindashboardLayoutTutorApplicationsLazyRoute: typeof AdmindashboardLayoutTutorApplicationsLazyRoute
  AdmindashboardLayoutTutorFeedbackLazyRoute: typeof AdmindashboardLayoutTutorFeedbackLazyRoute
  AdmindashboardLayoutUsersLazyRoute: typeof AdmindashboardLayoutUsersLazyRoute
  AdmindashboardLayoutIndexRoute: typeof AdmindashboardLayoutIndexRoute
  AdmindashboardLayoutClassesClassIdLazyRoute: typeof AdmindashboardLayoutClassesClassIdLazyRoute
  AdmindashboardLayoutClassesNewLazyRoute: typeof AdmindashboardLayoutClassesNewLazyRoute
  AdmindashboardLayoutEventsEventIdLazyRoute: typeof AdmindashboardLayoutEventsEventIdLazyRoute
  AdmindashboardLayoutEventsNewLazyRoute: typeof AdmindashboardLayoutEventsNewLazyRoute
  AdmindashboardLayoutFamilyFamilyIdLazyRoute: typeof AdmindashboardLayoutFamilyFamilyIdLazyRoute
  AdmindashboardLayoutInquiriesIdLazyRoute: typeof AdmindashboardLayoutInquiriesIdLazyRoute
  AdmindashboardLayoutMessagingNewLazyRoute: typeof AdmindashboardLayoutMessagingNewLazyRoute
  AdmindashboardLayoutStaffStaffIdLazyRoute: typeof AdmindashboardLayoutStaffStaffIdLazyRoute
  AdmindashboardLayoutStaffCreateLazyRoute: typeof AdmindashboardLayoutStaffCreateLazyRoute
  AdmindashboardLayoutTransactionsTransactionIdLazyRoute: typeof AdmindashboardLayoutTransactionsTransactionIdLazyRoute
  AdmindashboardLayoutUsersUserIdLazyRoute: typeof AdmindashboardLayoutUsersUserIdLazyRoute
  AdmindashboardLayoutClassesClassIdEditLazyRoute: typeof AdmindashboardLayoutClassesClassIdEditLazyRoute
  AdmindashboardLayoutEventsEventIdChargeLazyRoute: typeof AdmindashboardLayoutEventsEventIdChargeLazyRoute
  AdmindashboardLayoutEventsEventIdEditLazyRoute: typeof AdmindashboardLayoutEventsEventIdEditLazyRoute
  AdmindashboardLayoutFamilyFamilyIdEditLazyRoute: typeof AdmindashboardLayoutFamilyFamilyIdEditLazyRoute
  AdmindashboardLayoutInquiriesIdEditLazyRoute: typeof AdmindashboardLayoutInquiriesIdEditLazyRoute
  AdmindashboardLayoutMessagingRuleIdEditLazyRoute: typeof AdmindashboardLayoutMessagingRuleIdEditLazyRoute
  AdmindashboardLayoutStaffStaffIdEditLazyRoute: typeof AdmindashboardLayoutStaffStaffIdEditLazyRoute
  AdmindashboardLayoutTransactionsTransactionIdEditLazyRoute: typeof AdmindashboardLayoutTransactionsTransactionIdEditLazyRoute
  AdmindashboardLayoutUsersUserIdEditLazyRoute: typeof AdmindashboardLayoutUsersUserIdEditLazyRoute
}

const AdmindashboardLayoutRouteChildren: AdmindashboardLayoutRouteChildren = {
  AdmindashboardLayoutClassesRoute: AdmindashboardLayoutClassesRoute,
  AdmindashboardLayoutEventsRoute: AdmindashboardLayoutEventsRoute,
  AdmindashboardLayoutKpiRoute: AdmindashboardLayoutKpiRoute,
  AdmindashboardLayoutTransactionsRoute: AdmindashboardLayoutTransactionsRoute,
  AdmindashboardLayoutAnalyticsLazyRoute:
    AdmindashboardLayoutAnalyticsLazyRoute,
  AdmindashboardLayoutConfigurationsLazyRoute:
    AdmindashboardLayoutConfigurationsLazyRoute,
  AdmindashboardLayoutFamiliesLazyRoute: AdmindashboardLayoutFamiliesLazyRoute,
  AdmindashboardLayoutFilesLazyRoute: AdmindashboardLayoutFilesLazyRoute,
  AdmindashboardLayoutInquiriesLazyRoute:
    AdmindashboardLayoutInquiriesLazyRoute,
  AdmindashboardLayoutMessagingLazyRoute:
    AdmindashboardLayoutMessagingLazyRoute,
  AdmindashboardLayoutStaffLazyRoute: AdmindashboardLayoutStaffLazyRoute,
  AdmindashboardLayoutSubjectsLazyRoute: AdmindashboardLayoutSubjectsLazyRoute,
  AdmindashboardLayoutTutorApplicationsLazyRoute:
    AdmindashboardLayoutTutorApplicationsLazyRoute,
  AdmindashboardLayoutTutorFeedbackLazyRoute:
    AdmindashboardLayoutTutorFeedbackLazyRoute,
  AdmindashboardLayoutUsersLazyRoute: AdmindashboardLayoutUsersLazyRoute,
  AdmindashboardLayoutIndexRoute: AdmindashboardLayoutIndexRoute,
  AdmindashboardLayoutClassesClassIdLazyRoute:
    AdmindashboardLayoutClassesClassIdLazyRoute,
  AdmindashboardLayoutClassesNewLazyRoute:
    AdmindashboardLayoutClassesNewLazyRoute,
  AdmindashboardLayoutEventsEventIdLazyRoute:
    AdmindashboardLayoutEventsEventIdLazyRoute,
  AdmindashboardLayoutEventsNewLazyRoute:
    AdmindashboardLayoutEventsNewLazyRoute,
  AdmindashboardLayoutFamilyFamilyIdLazyRoute:
    AdmindashboardLayoutFamilyFamilyIdLazyRoute,
  AdmindashboardLayoutInquiriesIdLazyRoute:
    AdmindashboardLayoutInquiriesIdLazyRoute,
  AdmindashboardLayoutMessagingNewLazyRoute:
    AdmindashboardLayoutMessagingNewLazyRoute,
  AdmindashboardLayoutStaffStaffIdLazyRoute:
    AdmindashboardLayoutStaffStaffIdLazyRoute,
  AdmindashboardLayoutStaffCreateLazyRoute:
    AdmindashboardLayoutStaffCreateLazyRoute,
  AdmindashboardLayoutTransactionsTransactionIdLazyRoute:
    AdmindashboardLayoutTransactionsTransactionIdLazyRoute,
  AdmindashboardLayoutUsersUserIdLazyRoute:
    AdmindashboardLayoutUsersUserIdLazyRoute,
  AdmindashboardLayoutClassesClassIdEditLazyRoute:
    AdmindashboardLayoutClassesClassIdEditLazyRoute,
  AdmindashboardLayoutEventsEventIdChargeLazyRoute:
    AdmindashboardLayoutEventsEventIdChargeLazyRoute,
  AdmindashboardLayoutEventsEventIdEditLazyRoute:
    AdmindashboardLayoutEventsEventIdEditLazyRoute,
  AdmindashboardLayoutFamilyFamilyIdEditLazyRoute:
    AdmindashboardLayoutFamilyFamilyIdEditLazyRoute,
  AdmindashboardLayoutInquiriesIdEditLazyRoute:
    AdmindashboardLayoutInquiriesIdEditLazyRoute,
  AdmindashboardLayoutMessagingRuleIdEditLazyRoute:
    AdmindashboardLayoutMessagingRuleIdEditLazyRoute,
  AdmindashboardLayoutStaffStaffIdEditLazyRoute:
    AdmindashboardLayoutStaffStaffIdEditLazyRoute,
  AdmindashboardLayoutTransactionsTransactionIdEditLazyRoute:
    AdmindashboardLayoutTransactionsTransactionIdEditLazyRoute,
  AdmindashboardLayoutUsersUserIdEditLazyRoute:
    AdmindashboardLayoutUsersUserIdEditLazyRoute,
}

const AdmindashboardLayoutRouteWithChildren =
  AdmindashboardLayoutRoute._addFileChildren(AdmindashboardLayoutRouteChildren)

interface AdmindashboardRouteChildren {
  AdmindashboardLayoutRoute: typeof AdmindashboardLayoutRouteWithChildren
}

const AdmindashboardRouteChildren: AdmindashboardRouteChildren = {
  AdmindashboardLayoutRoute: AdmindashboardLayoutRouteWithChildren,
}

const AdmindashboardRouteWithChildren = AdmindashboardRoute._addFileChildren(
  AdmindashboardRouteChildren,
)

interface ClientdashboardLayoutRouteChildren {
  ClientdashboardLayoutCheckoutRoute: typeof ClientdashboardLayoutCheckoutRoute
  ClientdashboardLayoutEngagementagreementLazyRoute: typeof ClientdashboardLayoutEngagementagreementLazyRoute
  ClientdashboardLayoutEventsLazyRoute: typeof ClientdashboardLayoutEventsLazyRoute
  ClientdashboardLayoutOnboardLazyRoute: typeof ClientdashboardLayoutOnboardLazyRoute
  ClientdashboardLayoutIndexLazyRoute: typeof ClientdashboardLayoutIndexLazyRoute
  ClientdashboardLayoutStripeCheckoutRoute: typeof ClientdashboardLayoutStripeCheckoutRoute
  ClientdashboardLayoutEventEventIdLazyRoute: typeof ClientdashboardLayoutEventEventIdLazyRoute
  ClientdashboardLayoutStripeCancelLazyRoute: typeof ClientdashboardLayoutStripeCancelLazyRoute
  ClientdashboardLayoutStripeSuccessLazyRoute: typeof ClientdashboardLayoutStripeSuccessLazyRoute
}

const ClientdashboardLayoutRouteChildren: ClientdashboardLayoutRouteChildren = {
  ClientdashboardLayoutCheckoutRoute: ClientdashboardLayoutCheckoutRoute,
  ClientdashboardLayoutEngagementagreementLazyRoute:
    ClientdashboardLayoutEngagementagreementLazyRoute,
  ClientdashboardLayoutEventsLazyRoute: ClientdashboardLayoutEventsLazyRoute,
  ClientdashboardLayoutOnboardLazyRoute: ClientdashboardLayoutOnboardLazyRoute,
  ClientdashboardLayoutIndexLazyRoute: ClientdashboardLayoutIndexLazyRoute,
  ClientdashboardLayoutStripeCheckoutRoute:
    ClientdashboardLayoutStripeCheckoutRoute,
  ClientdashboardLayoutEventEventIdLazyRoute:
    ClientdashboardLayoutEventEventIdLazyRoute,
  ClientdashboardLayoutStripeCancelLazyRoute:
    ClientdashboardLayoutStripeCancelLazyRoute,
  ClientdashboardLayoutStripeSuccessLazyRoute:
    ClientdashboardLayoutStripeSuccessLazyRoute,
}

const ClientdashboardLayoutRouteWithChildren =
  ClientdashboardLayoutRoute._addFileChildren(
    ClientdashboardLayoutRouteChildren,
  )

interface ClientdashboardRouteChildren {
  ClientdashboardLayoutRoute: typeof ClientdashboardLayoutRouteWithChildren
}

const ClientdashboardRouteChildren: ClientdashboardRouteChildren = {
  ClientdashboardLayoutRoute: ClientdashboardLayoutRouteWithChildren,
}

const ClientdashboardRouteWithChildren = ClientdashboardRoute._addFileChildren(
  ClientdashboardRouteChildren,
)

interface TutordashboardLayoutRouteChildren {
  TutordashboardLayoutClientsLazyRoute: typeof TutordashboardLayoutClientsLazyRoute
  TutordashboardLayoutCreateBookingLazyRoute: typeof TutordashboardLayoutCreateBookingLazyRoute
  TutordashboardLayoutCreateEventLazyRoute: typeof TutordashboardLayoutCreateEventLazyRoute
  TutordashboardLayoutEventsLazyRoute: typeof TutordashboardLayoutEventsLazyRoute
  TutordashboardLayoutInquiriesLazyRoute: typeof TutordashboardLayoutInquiriesLazyRoute
  TutordashboardLayoutProfileLazyRoute: typeof TutordashboardLayoutProfileLazyRoute
  TutordashboardLayoutIndexLazyRoute: typeof TutordashboardLayoutIndexLazyRoute
  TutordashboardLayoutEventsEventIdLazyRoute: typeof TutordashboardLayoutEventsEventIdLazyRoute
  TutordashboardLayoutInquiriesIdLazyRoute: typeof TutordashboardLayoutInquiriesIdLazyRoute
}

const TutordashboardLayoutRouteChildren: TutordashboardLayoutRouteChildren = {
  TutordashboardLayoutClientsLazyRoute: TutordashboardLayoutClientsLazyRoute,
  TutordashboardLayoutCreateBookingLazyRoute:
    TutordashboardLayoutCreateBookingLazyRoute,
  TutordashboardLayoutCreateEventLazyRoute:
    TutordashboardLayoutCreateEventLazyRoute,
  TutordashboardLayoutEventsLazyRoute: TutordashboardLayoutEventsLazyRoute,
  TutordashboardLayoutInquiriesLazyRoute:
    TutordashboardLayoutInquiriesLazyRoute,
  TutordashboardLayoutProfileLazyRoute: TutordashboardLayoutProfileLazyRoute,
  TutordashboardLayoutIndexLazyRoute: TutordashboardLayoutIndexLazyRoute,
  TutordashboardLayoutEventsEventIdLazyRoute:
    TutordashboardLayoutEventsEventIdLazyRoute,
  TutordashboardLayoutInquiriesIdLazyRoute:
    TutordashboardLayoutInquiriesIdLazyRoute,
}

const TutordashboardLayoutRouteWithChildren =
  TutordashboardLayoutRoute._addFileChildren(TutordashboardLayoutRouteChildren)

interface TutordashboardRouteChildren {
  TutordashboardLayoutRoute: typeof TutordashboardLayoutRouteWithChildren
}

const TutordashboardRouteChildren: TutordashboardRouteChildren = {
  TutordashboardLayoutRoute: TutordashboardLayoutRouteWithChildren,
}

const TutordashboardRouteWithChildren = TutordashboardRoute._addFileChildren(
  TutordashboardRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/about': typeof AboutLazyRoute
  '/apply': typeof ApplyLazyRoute
  '/contact': typeof ContactLazyRoute
  '/feedback': typeof FeedbackLazyRoute
  '/feedback-form': typeof FeedbackFormLazyRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/how-to-guides': typeof HowToGuidesLazyRoute
  '/notifications': typeof NotificationsLazyRoute
  '/sign-up': typeof SignUpLazyRoute
  '/subjects': typeof SubjectsLazyRoute
  '/terms': typeof TermsLazyRoute
  '/tutors': typeof TutorsLazyRoute
  '/update-password': typeof UpdatePasswordLazyRoute
  '/admindashboard': typeof AdmindashboardLayoutRouteWithChildren
  '/classes/sign-up-confirmed': typeof ClassesSignUpConfirmedRoute
  '/clientdashboard': typeof ClientdashboardLayoutRouteWithChildren
  '/tutor/$tutorId': typeof TutorTutorIdRoute
  '/tutordashboard': typeof TutordashboardLayoutRouteWithChildren
  '/classes/browse': typeof ClassesBrowseLazyRoute
  '/college-advising/book-a-workshop': typeof CollegeAdvisingBookAWorkshopLazyRoute
  '/classes': typeof ClassesIndexLazyRoute
  '/college-advising': typeof CollegeAdvisingIndexLazyRoute
  '/admindashboard/classes': typeof AdmindashboardLayoutClassesRoute
  '/admindashboard/events': typeof AdmindashboardLayoutEventsRoute
  '/admindashboard/kpi': typeof AdmindashboardLayoutKpiRoute
  '/admindashboard/transactions': typeof AdmindashboardLayoutTransactionsRoute
  '/clientdashboard/checkout': typeof ClientdashboardLayoutCheckoutRoute
  '/admindashboard/analytics': typeof AdmindashboardLayoutAnalyticsLazyRoute
  '/admindashboard/configurations': typeof AdmindashboardLayoutConfigurationsLazyRoute
  '/admindashboard/families': typeof AdmindashboardLayoutFamiliesLazyRoute
  '/admindashboard/files': typeof AdmindashboardLayoutFilesLazyRoute
  '/admindashboard/inquiries': typeof AdmindashboardLayoutInquiriesLazyRoute
  '/admindashboard/messaging': typeof AdmindashboardLayoutMessagingLazyRoute
  '/admindashboard/staff': typeof AdmindashboardLayoutStaffLazyRoute
  '/admindashboard/subjects': typeof AdmindashboardLayoutSubjectsLazyRoute
  '/admindashboard/tutor-applications': typeof AdmindashboardLayoutTutorApplicationsLazyRoute
  '/admindashboard/tutor-feedback': typeof AdmindashboardLayoutTutorFeedbackLazyRoute
  '/admindashboard/users': typeof AdmindashboardLayoutUsersLazyRoute
  '/clientdashboard/engagement_agreement': typeof ClientdashboardLayoutEngagementagreementLazyRoute
  '/clientdashboard/events': typeof ClientdashboardLayoutEventsLazyRoute
  '/clientdashboard/onboard': typeof ClientdashboardLayoutOnboardLazyRoute
  '/tutordashboard/clients': typeof TutordashboardLayoutClientsLazyRoute
  '/tutordashboard/create-booking': typeof TutordashboardLayoutCreateBookingLazyRoute
  '/tutordashboard/create-event': typeof TutordashboardLayoutCreateEventLazyRoute
  '/tutordashboard/events': typeof TutordashboardLayoutEventsLazyRoute
  '/tutordashboard/inquiries': typeof TutordashboardLayoutInquiriesLazyRoute
  '/tutordashboard/profile': typeof TutordashboardLayoutProfileLazyRoute
  '/admindashboard/': typeof AdmindashboardLayoutIndexRoute
  '/clientdashboard/': typeof ClientdashboardLayoutIndexLazyRoute
  '/tutordashboard/': typeof TutordashboardLayoutIndexLazyRoute
  '/clientdashboard/stripe/checkout': typeof ClientdashboardLayoutStripeCheckoutRoute
  '/admindashboard/classes/$classId': typeof AdmindashboardLayoutClassesClassIdLazyRoute
  '/admindashboard/classes/new': typeof AdmindashboardLayoutClassesNewLazyRoute
  '/admindashboard/events/$eventId': typeof AdmindashboardLayoutEventsEventIdLazyRoute
  '/admindashboard/events/new': typeof AdmindashboardLayoutEventsNewLazyRoute
  '/admindashboard/family/$familyId': typeof AdmindashboardLayoutFamilyFamilyIdLazyRoute
  '/admindashboard/inquiries/$id': typeof AdmindashboardLayoutInquiriesIdLazyRoute
  '/admindashboard/messaging/new': typeof AdmindashboardLayoutMessagingNewLazyRoute
  '/admindashboard/staff/$staffId': typeof AdmindashboardLayoutStaffStaffIdLazyRoute
  '/admindashboard/staff/create': typeof AdmindashboardLayoutStaffCreateLazyRoute
  '/admindashboard/transactions/$transactionId': typeof AdmindashboardLayoutTransactionsTransactionIdLazyRoute
  '/admindashboard/users/$userId': typeof AdmindashboardLayoutUsersUserIdLazyRoute
  '/clientdashboard/event/$eventId': typeof ClientdashboardLayoutEventEventIdLazyRoute
  '/clientdashboard/stripe/cancel': typeof ClientdashboardLayoutStripeCancelLazyRoute
  '/clientdashboard/stripe/success': typeof ClientdashboardLayoutStripeSuccessLazyRoute
  '/tutordashboard/events/$eventId': typeof TutordashboardLayoutEventsEventIdLazyRoute
  '/tutordashboard/inquiries/$id': typeof TutordashboardLayoutInquiriesIdLazyRoute
  '/admindashboard/classes/$classId/edit': typeof AdmindashboardLayoutClassesClassIdEditLazyRoute
  '/admindashboard/events/$eventId/charge': typeof AdmindashboardLayoutEventsEventIdChargeLazyRoute
  '/admindashboard/events/$eventId/edit': typeof AdmindashboardLayoutEventsEventIdEditLazyRoute
  '/admindashboard/family/$familyId/edit': typeof AdmindashboardLayoutFamilyFamilyIdEditLazyRoute
  '/admindashboard/inquiries/$id/edit': typeof AdmindashboardLayoutInquiriesIdEditLazyRoute
  '/admindashboard/messaging/$ruleId/edit': typeof AdmindashboardLayoutMessagingRuleIdEditLazyRoute
  '/admindashboard/staff/$staffId/edit': typeof AdmindashboardLayoutStaffStaffIdEditLazyRoute
  '/admindashboard/transactions/$transactionId/edit': typeof AdmindashboardLayoutTransactionsTransactionIdEditLazyRoute
  '/admindashboard/users/$userId/edit': typeof AdmindashboardLayoutUsersUserIdEditLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/about': typeof AboutLazyRoute
  '/apply': typeof ApplyLazyRoute
  '/contact': typeof ContactLazyRoute
  '/feedback': typeof FeedbackLazyRoute
  '/feedback-form': typeof FeedbackFormLazyRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/how-to-guides': typeof HowToGuidesLazyRoute
  '/notifications': typeof NotificationsLazyRoute
  '/sign-up': typeof SignUpLazyRoute
  '/subjects': typeof SubjectsLazyRoute
  '/terms': typeof TermsLazyRoute
  '/tutors': typeof TutorsLazyRoute
  '/update-password': typeof UpdatePasswordLazyRoute
  '/admindashboard': typeof AdmindashboardLayoutIndexRoute
  '/classes/sign-up-confirmed': typeof ClassesSignUpConfirmedRoute
  '/clientdashboard': typeof ClientdashboardLayoutIndexLazyRoute
  '/tutor/$tutorId': typeof TutorTutorIdRoute
  '/tutordashboard': typeof TutordashboardLayoutIndexLazyRoute
  '/classes/browse': typeof ClassesBrowseLazyRoute
  '/college-advising/book-a-workshop': typeof CollegeAdvisingBookAWorkshopLazyRoute
  '/classes': typeof ClassesIndexLazyRoute
  '/college-advising': typeof CollegeAdvisingIndexLazyRoute
  '/admindashboard/classes': typeof AdmindashboardLayoutClassesRoute
  '/admindashboard/events': typeof AdmindashboardLayoutEventsRoute
  '/admindashboard/kpi': typeof AdmindashboardLayoutKpiRoute
  '/admindashboard/transactions': typeof AdmindashboardLayoutTransactionsRoute
  '/clientdashboard/checkout': typeof ClientdashboardLayoutCheckoutRoute
  '/admindashboard/analytics': typeof AdmindashboardLayoutAnalyticsLazyRoute
  '/admindashboard/configurations': typeof AdmindashboardLayoutConfigurationsLazyRoute
  '/admindashboard/families': typeof AdmindashboardLayoutFamiliesLazyRoute
  '/admindashboard/files': typeof AdmindashboardLayoutFilesLazyRoute
  '/admindashboard/inquiries': typeof AdmindashboardLayoutInquiriesLazyRoute
  '/admindashboard/messaging': typeof AdmindashboardLayoutMessagingLazyRoute
  '/admindashboard/staff': typeof AdmindashboardLayoutStaffLazyRoute
  '/admindashboard/subjects': typeof AdmindashboardLayoutSubjectsLazyRoute
  '/admindashboard/tutor-applications': typeof AdmindashboardLayoutTutorApplicationsLazyRoute
  '/admindashboard/tutor-feedback': typeof AdmindashboardLayoutTutorFeedbackLazyRoute
  '/admindashboard/users': typeof AdmindashboardLayoutUsersLazyRoute
  '/clientdashboard/engagement_agreement': typeof ClientdashboardLayoutEngagementagreementLazyRoute
  '/clientdashboard/events': typeof ClientdashboardLayoutEventsLazyRoute
  '/clientdashboard/onboard': typeof ClientdashboardLayoutOnboardLazyRoute
  '/tutordashboard/clients': typeof TutordashboardLayoutClientsLazyRoute
  '/tutordashboard/create-booking': typeof TutordashboardLayoutCreateBookingLazyRoute
  '/tutordashboard/create-event': typeof TutordashboardLayoutCreateEventLazyRoute
  '/tutordashboard/events': typeof TutordashboardLayoutEventsLazyRoute
  '/tutordashboard/inquiries': typeof TutordashboardLayoutInquiriesLazyRoute
  '/tutordashboard/profile': typeof TutordashboardLayoutProfileLazyRoute
  '/clientdashboard/stripe/checkout': typeof ClientdashboardLayoutStripeCheckoutRoute
  '/admindashboard/classes/$classId': typeof AdmindashboardLayoutClassesClassIdLazyRoute
  '/admindashboard/classes/new': typeof AdmindashboardLayoutClassesNewLazyRoute
  '/admindashboard/events/$eventId': typeof AdmindashboardLayoutEventsEventIdLazyRoute
  '/admindashboard/events/new': typeof AdmindashboardLayoutEventsNewLazyRoute
  '/admindashboard/family/$familyId': typeof AdmindashboardLayoutFamilyFamilyIdLazyRoute
  '/admindashboard/inquiries/$id': typeof AdmindashboardLayoutInquiriesIdLazyRoute
  '/admindashboard/messaging/new': typeof AdmindashboardLayoutMessagingNewLazyRoute
  '/admindashboard/staff/$staffId': typeof AdmindashboardLayoutStaffStaffIdLazyRoute
  '/admindashboard/staff/create': typeof AdmindashboardLayoutStaffCreateLazyRoute
  '/admindashboard/transactions/$transactionId': typeof AdmindashboardLayoutTransactionsTransactionIdLazyRoute
  '/admindashboard/users/$userId': typeof AdmindashboardLayoutUsersUserIdLazyRoute
  '/clientdashboard/event/$eventId': typeof ClientdashboardLayoutEventEventIdLazyRoute
  '/clientdashboard/stripe/cancel': typeof ClientdashboardLayoutStripeCancelLazyRoute
  '/clientdashboard/stripe/success': typeof ClientdashboardLayoutStripeSuccessLazyRoute
  '/tutordashboard/events/$eventId': typeof TutordashboardLayoutEventsEventIdLazyRoute
  '/tutordashboard/inquiries/$id': typeof TutordashboardLayoutInquiriesIdLazyRoute
  '/admindashboard/classes/$classId/edit': typeof AdmindashboardLayoutClassesClassIdEditLazyRoute
  '/admindashboard/events/$eventId/charge': typeof AdmindashboardLayoutEventsEventIdChargeLazyRoute
  '/admindashboard/events/$eventId/edit': typeof AdmindashboardLayoutEventsEventIdEditLazyRoute
  '/admindashboard/family/$familyId/edit': typeof AdmindashboardLayoutFamilyFamilyIdEditLazyRoute
  '/admindashboard/inquiries/$id/edit': typeof AdmindashboardLayoutInquiriesIdEditLazyRoute
  '/admindashboard/messaging/$ruleId/edit': typeof AdmindashboardLayoutMessagingRuleIdEditLazyRoute
  '/admindashboard/staff/$staffId/edit': typeof AdmindashboardLayoutStaffStaffIdEditLazyRoute
  '/admindashboard/transactions/$transactionId/edit': typeof AdmindashboardLayoutTransactionsTransactionIdEditLazyRoute
  '/admindashboard/users/$userId/edit': typeof AdmindashboardLayoutUsersUserIdEditLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/about': typeof AboutLazyRoute
  '/apply': typeof ApplyLazyRoute
  '/contact': typeof ContactLazyRoute
  '/feedback': typeof FeedbackLazyRoute
  '/feedback-form': typeof FeedbackFormLazyRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/how-to-guides': typeof HowToGuidesLazyRoute
  '/notifications': typeof NotificationsLazyRoute
  '/sign-up': typeof SignUpLazyRoute
  '/subjects': typeof SubjectsLazyRoute
  '/terms': typeof TermsLazyRoute
  '/tutors': typeof TutorsLazyRoute
  '/update-password': typeof UpdatePasswordLazyRoute
  '/admindashboard': typeof AdmindashboardRouteWithChildren
  '/admindashboard/_layout': typeof AdmindashboardLayoutRouteWithChildren
  '/classes/sign-up-confirmed': typeof ClassesSignUpConfirmedRoute
  '/clientdashboard': typeof ClientdashboardRouteWithChildren
  '/clientdashboard/_layout': typeof ClientdashboardLayoutRouteWithChildren
  '/tutor/$tutorId': typeof TutorTutorIdRoute
  '/tutordashboard': typeof TutordashboardRouteWithChildren
  '/tutordashboard/_layout': typeof TutordashboardLayoutRouteWithChildren
  '/classes/browse': typeof ClassesBrowseLazyRoute
  '/college-advising/book-a-workshop': typeof CollegeAdvisingBookAWorkshopLazyRoute
  '/classes/': typeof ClassesIndexLazyRoute
  '/college-advising/': typeof CollegeAdvisingIndexLazyRoute
  '/admindashboard/_layout/classes': typeof AdmindashboardLayoutClassesRoute
  '/admindashboard/_layout/events': typeof AdmindashboardLayoutEventsRoute
  '/admindashboard/_layout/kpi': typeof AdmindashboardLayoutKpiRoute
  '/admindashboard/_layout/transactions': typeof AdmindashboardLayoutTransactionsRoute
  '/clientdashboard/_layout/checkout': typeof ClientdashboardLayoutCheckoutRoute
  '/admindashboard/_layout/analytics': typeof AdmindashboardLayoutAnalyticsLazyRoute
  '/admindashboard/_layout/configurations': typeof AdmindashboardLayoutConfigurationsLazyRoute
  '/admindashboard/_layout/families': typeof AdmindashboardLayoutFamiliesLazyRoute
  '/admindashboard/_layout/files': typeof AdmindashboardLayoutFilesLazyRoute
  '/admindashboard/_layout/inquiries': typeof AdmindashboardLayoutInquiriesLazyRoute
  '/admindashboard/_layout/messaging': typeof AdmindashboardLayoutMessagingLazyRoute
  '/admindashboard/_layout/staff': typeof AdmindashboardLayoutStaffLazyRoute
  '/admindashboard/_layout/subjects': typeof AdmindashboardLayoutSubjectsLazyRoute
  '/admindashboard/_layout/tutor-applications': typeof AdmindashboardLayoutTutorApplicationsLazyRoute
  '/admindashboard/_layout/tutor-feedback': typeof AdmindashboardLayoutTutorFeedbackLazyRoute
  '/admindashboard/_layout/users': typeof AdmindashboardLayoutUsersLazyRoute
  '/clientdashboard/_layout/engagement_agreement': typeof ClientdashboardLayoutEngagementagreementLazyRoute
  '/clientdashboard/_layout/events': typeof ClientdashboardLayoutEventsLazyRoute
  '/clientdashboard/_layout/onboard': typeof ClientdashboardLayoutOnboardLazyRoute
  '/tutordashboard/_layout/clients': typeof TutordashboardLayoutClientsLazyRoute
  '/tutordashboard/_layout/create-booking': typeof TutordashboardLayoutCreateBookingLazyRoute
  '/tutordashboard/_layout/create-event': typeof TutordashboardLayoutCreateEventLazyRoute
  '/tutordashboard/_layout/events': typeof TutordashboardLayoutEventsLazyRoute
  '/tutordashboard/_layout/inquiries': typeof TutordashboardLayoutInquiriesLazyRoute
  '/tutordashboard/_layout/profile': typeof TutordashboardLayoutProfileLazyRoute
  '/admindashboard/_layout/': typeof AdmindashboardLayoutIndexRoute
  '/clientdashboard/_layout/': typeof ClientdashboardLayoutIndexLazyRoute
  '/tutordashboard/_layout/': typeof TutordashboardLayoutIndexLazyRoute
  '/clientdashboard/_layout/stripe/checkout': typeof ClientdashboardLayoutStripeCheckoutRoute
  '/admindashboard/_layout/classes_/$classId': typeof AdmindashboardLayoutClassesClassIdLazyRoute
  '/admindashboard/_layout/classes_/new': typeof AdmindashboardLayoutClassesNewLazyRoute
  '/admindashboard/_layout/events_/$eventId': typeof AdmindashboardLayoutEventsEventIdLazyRoute
  '/admindashboard/_layout/events_/new': typeof AdmindashboardLayoutEventsNewLazyRoute
  '/admindashboard/_layout/family/$familyId': typeof AdmindashboardLayoutFamilyFamilyIdLazyRoute
  '/admindashboard/_layout/inquiries_/$id': typeof AdmindashboardLayoutInquiriesIdLazyRoute
  '/admindashboard/_layout/messaging_/new': typeof AdmindashboardLayoutMessagingNewLazyRoute
  '/admindashboard/_layout/staff_/$staffId': typeof AdmindashboardLayoutStaffStaffIdLazyRoute
  '/admindashboard/_layout/staff_/create': typeof AdmindashboardLayoutStaffCreateLazyRoute
  '/admindashboard/_layout/transactions_/$transactionId': typeof AdmindashboardLayoutTransactionsTransactionIdLazyRoute
  '/admindashboard/_layout/users_/$userId': typeof AdmindashboardLayoutUsersUserIdLazyRoute
  '/clientdashboard/_layout/event/$eventId': typeof ClientdashboardLayoutEventEventIdLazyRoute
  '/clientdashboard/_layout/stripe/cancel': typeof ClientdashboardLayoutStripeCancelLazyRoute
  '/clientdashboard/_layout/stripe/success': typeof ClientdashboardLayoutStripeSuccessLazyRoute
  '/tutordashboard/_layout/events_/$eventId': typeof TutordashboardLayoutEventsEventIdLazyRoute
  '/tutordashboard/_layout/inquiries_/$id': typeof TutordashboardLayoutInquiriesIdLazyRoute
  '/admindashboard/_layout/classes_/$classId_/edit': typeof AdmindashboardLayoutClassesClassIdEditLazyRoute
  '/admindashboard/_layout/events_/$eventId_/charge': typeof AdmindashboardLayoutEventsEventIdChargeLazyRoute
  '/admindashboard/_layout/events_/$eventId_/edit': typeof AdmindashboardLayoutEventsEventIdEditLazyRoute
  '/admindashboard/_layout/family/$familyId_/edit': typeof AdmindashboardLayoutFamilyFamilyIdEditLazyRoute
  '/admindashboard/_layout/inquiries_/$id_/edit': typeof AdmindashboardLayoutInquiriesIdEditLazyRoute
  '/admindashboard/_layout/messaging_/$ruleId/edit': typeof AdmindashboardLayoutMessagingRuleIdEditLazyRoute
  '/admindashboard/_layout/staff_/$staffId_/edit': typeof AdmindashboardLayoutStaffStaffIdEditLazyRoute
  '/admindashboard/_layout/transactions_/$transactionId_/edit': typeof AdmindashboardLayoutTransactionsTransactionIdEditLazyRoute
  '/admindashboard/_layout/users_/$userId_/edit': typeof AdmindashboardLayoutUsersUserIdEditLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/confirm-email'
    | '/login'
    | '/unauthorized'
    | '/about'
    | '/apply'
    | '/contact'
    | '/feedback'
    | '/feedback-form'
    | '/forgot-password'
    | '/how-to-guides'
    | '/notifications'
    | '/sign-up'
    | '/subjects'
    | '/terms'
    | '/tutors'
    | '/update-password'
    | '/admindashboard'
    | '/classes/sign-up-confirmed'
    | '/clientdashboard'
    | '/tutor/$tutorId'
    | '/tutordashboard'
    | '/classes/browse'
    | '/college-advising/book-a-workshop'
    | '/classes'
    | '/college-advising'
    | '/admindashboard/classes'
    | '/admindashboard/events'
    | '/admindashboard/kpi'
    | '/admindashboard/transactions'
    | '/clientdashboard/checkout'
    | '/admindashboard/analytics'
    | '/admindashboard/configurations'
    | '/admindashboard/families'
    | '/admindashboard/files'
    | '/admindashboard/inquiries'
    | '/admindashboard/messaging'
    | '/admindashboard/staff'
    | '/admindashboard/subjects'
    | '/admindashboard/tutor-applications'
    | '/admindashboard/tutor-feedback'
    | '/admindashboard/users'
    | '/clientdashboard/engagement_agreement'
    | '/clientdashboard/events'
    | '/clientdashboard/onboard'
    | '/tutordashboard/clients'
    | '/tutordashboard/create-booking'
    | '/tutordashboard/create-event'
    | '/tutordashboard/events'
    | '/tutordashboard/inquiries'
    | '/tutordashboard/profile'
    | '/admindashboard/'
    | '/clientdashboard/'
    | '/tutordashboard/'
    | '/clientdashboard/stripe/checkout'
    | '/admindashboard/classes/$classId'
    | '/admindashboard/classes/new'
    | '/admindashboard/events/$eventId'
    | '/admindashboard/events/new'
    | '/admindashboard/family/$familyId'
    | '/admindashboard/inquiries/$id'
    | '/admindashboard/messaging/new'
    | '/admindashboard/staff/$staffId'
    | '/admindashboard/staff/create'
    | '/admindashboard/transactions/$transactionId'
    | '/admindashboard/users/$userId'
    | '/clientdashboard/event/$eventId'
    | '/clientdashboard/stripe/cancel'
    | '/clientdashboard/stripe/success'
    | '/tutordashboard/events/$eventId'
    | '/tutordashboard/inquiries/$id'
    | '/admindashboard/classes/$classId/edit'
    | '/admindashboard/events/$eventId/charge'
    | '/admindashboard/events/$eventId/edit'
    | '/admindashboard/family/$familyId/edit'
    | '/admindashboard/inquiries/$id/edit'
    | '/admindashboard/messaging/$ruleId/edit'
    | '/admindashboard/staff/$staffId/edit'
    | '/admindashboard/transactions/$transactionId/edit'
    | '/admindashboard/users/$userId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/confirm-email'
    | '/login'
    | '/unauthorized'
    | '/about'
    | '/apply'
    | '/contact'
    | '/feedback'
    | '/feedback-form'
    | '/forgot-password'
    | '/how-to-guides'
    | '/notifications'
    | '/sign-up'
    | '/subjects'
    | '/terms'
    | '/tutors'
    | '/update-password'
    | '/admindashboard'
    | '/classes/sign-up-confirmed'
    | '/clientdashboard'
    | '/tutor/$tutorId'
    | '/tutordashboard'
    | '/classes/browse'
    | '/college-advising/book-a-workshop'
    | '/classes'
    | '/college-advising'
    | '/admindashboard/classes'
    | '/admindashboard/events'
    | '/admindashboard/kpi'
    | '/admindashboard/transactions'
    | '/clientdashboard/checkout'
    | '/admindashboard/analytics'
    | '/admindashboard/configurations'
    | '/admindashboard/families'
    | '/admindashboard/files'
    | '/admindashboard/inquiries'
    | '/admindashboard/messaging'
    | '/admindashboard/staff'
    | '/admindashboard/subjects'
    | '/admindashboard/tutor-applications'
    | '/admindashboard/tutor-feedback'
    | '/admindashboard/users'
    | '/clientdashboard/engagement_agreement'
    | '/clientdashboard/events'
    | '/clientdashboard/onboard'
    | '/tutordashboard/clients'
    | '/tutordashboard/create-booking'
    | '/tutordashboard/create-event'
    | '/tutordashboard/events'
    | '/tutordashboard/inquiries'
    | '/tutordashboard/profile'
    | '/clientdashboard/stripe/checkout'
    | '/admindashboard/classes/$classId'
    | '/admindashboard/classes/new'
    | '/admindashboard/events/$eventId'
    | '/admindashboard/events/new'
    | '/admindashboard/family/$familyId'
    | '/admindashboard/inquiries/$id'
    | '/admindashboard/messaging/new'
    | '/admindashboard/staff/$staffId'
    | '/admindashboard/staff/create'
    | '/admindashboard/transactions/$transactionId'
    | '/admindashboard/users/$userId'
    | '/clientdashboard/event/$eventId'
    | '/clientdashboard/stripe/cancel'
    | '/clientdashboard/stripe/success'
    | '/tutordashboard/events/$eventId'
    | '/tutordashboard/inquiries/$id'
    | '/admindashboard/classes/$classId/edit'
    | '/admindashboard/events/$eventId/charge'
    | '/admindashboard/events/$eventId/edit'
    | '/admindashboard/family/$familyId/edit'
    | '/admindashboard/inquiries/$id/edit'
    | '/admindashboard/messaging/$ruleId/edit'
    | '/admindashboard/staff/$staffId/edit'
    | '/admindashboard/transactions/$transactionId/edit'
    | '/admindashboard/users/$userId/edit'
  id:
    | '__root__'
    | '/'
    | '/confirm-email'
    | '/login'
    | '/unauthorized'
    | '/about'
    | '/apply'
    | '/contact'
    | '/feedback'
    | '/feedback-form'
    | '/forgot-password'
    | '/how-to-guides'
    | '/notifications'
    | '/sign-up'
    | '/subjects'
    | '/terms'
    | '/tutors'
    | '/update-password'
    | '/admindashboard'
    | '/admindashboard/_layout'
    | '/classes/sign-up-confirmed'
    | '/clientdashboard'
    | '/clientdashboard/_layout'
    | '/tutor/$tutorId'
    | '/tutordashboard'
    | '/tutordashboard/_layout'
    | '/classes/browse'
    | '/college-advising/book-a-workshop'
    | '/classes/'
    | '/college-advising/'
    | '/admindashboard/_layout/classes'
    | '/admindashboard/_layout/events'
    | '/admindashboard/_layout/kpi'
    | '/admindashboard/_layout/transactions'
    | '/clientdashboard/_layout/checkout'
    | '/admindashboard/_layout/analytics'
    | '/admindashboard/_layout/configurations'
    | '/admindashboard/_layout/families'
    | '/admindashboard/_layout/files'
    | '/admindashboard/_layout/inquiries'
    | '/admindashboard/_layout/messaging'
    | '/admindashboard/_layout/staff'
    | '/admindashboard/_layout/subjects'
    | '/admindashboard/_layout/tutor-applications'
    | '/admindashboard/_layout/tutor-feedback'
    | '/admindashboard/_layout/users'
    | '/clientdashboard/_layout/engagement_agreement'
    | '/clientdashboard/_layout/events'
    | '/clientdashboard/_layout/onboard'
    | '/tutordashboard/_layout/clients'
    | '/tutordashboard/_layout/create-booking'
    | '/tutordashboard/_layout/create-event'
    | '/tutordashboard/_layout/events'
    | '/tutordashboard/_layout/inquiries'
    | '/tutordashboard/_layout/profile'
    | '/admindashboard/_layout/'
    | '/clientdashboard/_layout/'
    | '/tutordashboard/_layout/'
    | '/clientdashboard/_layout/stripe/checkout'
    | '/admindashboard/_layout/classes_/$classId'
    | '/admindashboard/_layout/classes_/new'
    | '/admindashboard/_layout/events_/$eventId'
    | '/admindashboard/_layout/events_/new'
    | '/admindashboard/_layout/family/$familyId'
    | '/admindashboard/_layout/inquiries_/$id'
    | '/admindashboard/_layout/messaging_/new'
    | '/admindashboard/_layout/staff_/$staffId'
    | '/admindashboard/_layout/staff_/create'
    | '/admindashboard/_layout/transactions_/$transactionId'
    | '/admindashboard/_layout/users_/$userId'
    | '/clientdashboard/_layout/event/$eventId'
    | '/clientdashboard/_layout/stripe/cancel'
    | '/clientdashboard/_layout/stripe/success'
    | '/tutordashboard/_layout/events_/$eventId'
    | '/tutordashboard/_layout/inquiries_/$id'
    | '/admindashboard/_layout/classes_/$classId_/edit'
    | '/admindashboard/_layout/events_/$eventId_/charge'
    | '/admindashboard/_layout/events_/$eventId_/edit'
    | '/admindashboard/_layout/family/$familyId_/edit'
    | '/admindashboard/_layout/inquiries_/$id_/edit'
    | '/admindashboard/_layout/messaging_/$ruleId/edit'
    | '/admindashboard/_layout/staff_/$staffId_/edit'
    | '/admindashboard/_layout/transactions_/$transactionId_/edit'
    | '/admindashboard/_layout/users_/$userId_/edit'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConfirmEmailRoute: typeof ConfirmEmailRoute
  LoginRoute: typeof LoginRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  AboutLazyRoute: typeof AboutLazyRoute
  ApplyLazyRoute: typeof ApplyLazyRoute
  ContactLazyRoute: typeof ContactLazyRoute
  FeedbackLazyRoute: typeof FeedbackLazyRoute
  FeedbackFormLazyRoute: typeof FeedbackFormLazyRoute
  ForgotPasswordLazyRoute: typeof ForgotPasswordLazyRoute
  HowToGuidesLazyRoute: typeof HowToGuidesLazyRoute
  NotificationsLazyRoute: typeof NotificationsLazyRoute
  SignUpLazyRoute: typeof SignUpLazyRoute
  SubjectsLazyRoute: typeof SubjectsLazyRoute
  TermsLazyRoute: typeof TermsLazyRoute
  TutorsLazyRoute: typeof TutorsLazyRoute
  UpdatePasswordLazyRoute: typeof UpdatePasswordLazyRoute
  AdmindashboardRoute: typeof AdmindashboardRouteWithChildren
  ClassesSignUpConfirmedRoute: typeof ClassesSignUpConfirmedRoute
  ClientdashboardRoute: typeof ClientdashboardRouteWithChildren
  TutorTutorIdRoute: typeof TutorTutorIdRoute
  TutordashboardRoute: typeof TutordashboardRouteWithChildren
  ClassesBrowseLazyRoute: typeof ClassesBrowseLazyRoute
  CollegeAdvisingBookAWorkshopLazyRoute: typeof CollegeAdvisingBookAWorkshopLazyRoute
  ClassesIndexLazyRoute: typeof ClassesIndexLazyRoute
  CollegeAdvisingIndexLazyRoute: typeof CollegeAdvisingIndexLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConfirmEmailRoute: ConfirmEmailRoute,
  LoginRoute: LoginRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  AboutLazyRoute: AboutLazyRoute,
  ApplyLazyRoute: ApplyLazyRoute,
  ContactLazyRoute: ContactLazyRoute,
  FeedbackLazyRoute: FeedbackLazyRoute,
  FeedbackFormLazyRoute: FeedbackFormLazyRoute,
  ForgotPasswordLazyRoute: ForgotPasswordLazyRoute,
  HowToGuidesLazyRoute: HowToGuidesLazyRoute,
  NotificationsLazyRoute: NotificationsLazyRoute,
  SignUpLazyRoute: SignUpLazyRoute,
  SubjectsLazyRoute: SubjectsLazyRoute,
  TermsLazyRoute: TermsLazyRoute,
  TutorsLazyRoute: TutorsLazyRoute,
  UpdatePasswordLazyRoute: UpdatePasswordLazyRoute,
  AdmindashboardRoute: AdmindashboardRouteWithChildren,
  ClassesSignUpConfirmedRoute: ClassesSignUpConfirmedRoute,
  ClientdashboardRoute: ClientdashboardRouteWithChildren,
  TutorTutorIdRoute: TutorTutorIdRoute,
  TutordashboardRoute: TutordashboardRouteWithChildren,
  ClassesBrowseLazyRoute: ClassesBrowseLazyRoute,
  CollegeAdvisingBookAWorkshopLazyRoute: CollegeAdvisingBookAWorkshopLazyRoute,
  ClassesIndexLazyRoute: ClassesIndexLazyRoute,
  CollegeAdvisingIndexLazyRoute: CollegeAdvisingIndexLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/confirm-email",
        "/login",
        "/unauthorized",
        "/about",
        "/apply",
        "/contact",
        "/feedback",
        "/feedback-form",
        "/forgot-password",
        "/how-to-guides",
        "/notifications",
        "/sign-up",
        "/subjects",
        "/terms",
        "/tutors",
        "/update-password",
        "/admindashboard",
        "/classes/sign-up-confirmed",
        "/clientdashboard",
        "/tutor/$tutorId",
        "/tutordashboard",
        "/classes/browse",
        "/college-advising/book-a-workshop",
        "/classes/",
        "/college-advising/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/confirm-email": {
      "filePath": "confirm-email.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/unauthorized": {
      "filePath": "unauthorized.tsx"
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/apply": {
      "filePath": "apply.lazy.tsx"
    },
    "/contact": {
      "filePath": "contact.lazy.tsx"
    },
    "/feedback": {
      "filePath": "feedback.lazy.tsx"
    },
    "/feedback-form": {
      "filePath": "feedback-form.lazy.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.lazy.tsx"
    },
    "/how-to-guides": {
      "filePath": "how-to-guides.lazy.tsx"
    },
    "/notifications": {
      "filePath": "notifications.lazy.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.lazy.tsx"
    },
    "/subjects": {
      "filePath": "subjects.lazy.tsx"
    },
    "/terms": {
      "filePath": "terms.lazy.tsx"
    },
    "/tutors": {
      "filePath": "tutors.lazy.tsx"
    },
    "/update-password": {
      "filePath": "update-password.lazy.tsx"
    },
    "/admindashboard": {
      "filePath": "admindashboard",
      "children": [
        "/admindashboard/_layout"
      ]
    },
    "/admindashboard/_layout": {
      "filePath": "admindashboard/_layout.tsx",
      "parent": "/admindashboard",
      "children": [
        "/admindashboard/_layout/classes",
        "/admindashboard/_layout/events",
        "/admindashboard/_layout/kpi",
        "/admindashboard/_layout/transactions",
        "/admindashboard/_layout/analytics",
        "/admindashboard/_layout/configurations",
        "/admindashboard/_layout/families",
        "/admindashboard/_layout/files",
        "/admindashboard/_layout/inquiries",
        "/admindashboard/_layout/messaging",
        "/admindashboard/_layout/staff",
        "/admindashboard/_layout/subjects",
        "/admindashboard/_layout/tutor-applications",
        "/admindashboard/_layout/tutor-feedback",
        "/admindashboard/_layout/users",
        "/admindashboard/_layout/",
        "/admindashboard/_layout/classes_/$classId",
        "/admindashboard/_layout/classes_/new",
        "/admindashboard/_layout/events_/$eventId",
        "/admindashboard/_layout/events_/new",
        "/admindashboard/_layout/family/$familyId",
        "/admindashboard/_layout/inquiries_/$id",
        "/admindashboard/_layout/messaging_/new",
        "/admindashboard/_layout/staff_/$staffId",
        "/admindashboard/_layout/staff_/create",
        "/admindashboard/_layout/transactions_/$transactionId",
        "/admindashboard/_layout/users_/$userId",
        "/admindashboard/_layout/classes_/$classId_/edit",
        "/admindashboard/_layout/events_/$eventId_/charge",
        "/admindashboard/_layout/events_/$eventId_/edit",
        "/admindashboard/_layout/family/$familyId_/edit",
        "/admindashboard/_layout/inquiries_/$id_/edit",
        "/admindashboard/_layout/messaging_/$ruleId/edit",
        "/admindashboard/_layout/staff_/$staffId_/edit",
        "/admindashboard/_layout/transactions_/$transactionId_/edit",
        "/admindashboard/_layout/users_/$userId_/edit"
      ]
    },
    "/classes/sign-up-confirmed": {
      "filePath": "classes/sign-up-confirmed.tsx"
    },
    "/clientdashboard": {
      "filePath": "clientdashboard",
      "children": [
        "/clientdashboard/_layout"
      ]
    },
    "/clientdashboard/_layout": {
      "filePath": "clientdashboard/_layout.tsx",
      "parent": "/clientdashboard",
      "children": [
        "/clientdashboard/_layout/checkout",
        "/clientdashboard/_layout/engagement_agreement",
        "/clientdashboard/_layout/events",
        "/clientdashboard/_layout/onboard",
        "/clientdashboard/_layout/",
        "/clientdashboard/_layout/stripe/checkout",
        "/clientdashboard/_layout/event/$eventId",
        "/clientdashboard/_layout/stripe/cancel",
        "/clientdashboard/_layout/stripe/success"
      ]
    },
    "/tutor/$tutorId": {
      "filePath": "tutor.$tutorId.tsx"
    },
    "/tutordashboard": {
      "filePath": "tutordashboard",
      "children": [
        "/tutordashboard/_layout"
      ]
    },
    "/tutordashboard/_layout": {
      "filePath": "tutordashboard/_layout.tsx",
      "parent": "/tutordashboard",
      "children": [
        "/tutordashboard/_layout/clients",
        "/tutordashboard/_layout/create-booking",
        "/tutordashboard/_layout/create-event",
        "/tutordashboard/_layout/events",
        "/tutordashboard/_layout/inquiries",
        "/tutordashboard/_layout/profile",
        "/tutordashboard/_layout/",
        "/tutordashboard/_layout/events_/$eventId",
        "/tutordashboard/_layout/inquiries_/$id"
      ]
    },
    "/classes/browse": {
      "filePath": "classes/browse.lazy.tsx"
    },
    "/college-advising/book-a-workshop": {
      "filePath": "college-advising/book-a-workshop.lazy.tsx"
    },
    "/classes/": {
      "filePath": "classes/index.lazy.tsx"
    },
    "/college-advising/": {
      "filePath": "college-advising/index.lazy.tsx"
    },
    "/admindashboard/_layout/classes": {
      "filePath": "admindashboard/_layout/classes.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/events": {
      "filePath": "admindashboard/_layout/events.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/kpi": {
      "filePath": "admindashboard/_layout/kpi.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/transactions": {
      "filePath": "admindashboard/_layout/transactions.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/clientdashboard/_layout/checkout": {
      "filePath": "clientdashboard/_layout/checkout.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/admindashboard/_layout/analytics": {
      "filePath": "admindashboard/_layout/analytics.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/configurations": {
      "filePath": "admindashboard/_layout/configurations.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/families": {
      "filePath": "admindashboard/_layout/families.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/files": {
      "filePath": "admindashboard/_layout/files.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/inquiries": {
      "filePath": "admindashboard/_layout/inquiries.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/messaging": {
      "filePath": "admindashboard/_layout/messaging.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/staff": {
      "filePath": "admindashboard/_layout/staff.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/subjects": {
      "filePath": "admindashboard/_layout/subjects.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/tutor-applications": {
      "filePath": "admindashboard/_layout/tutor-applications.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/tutor-feedback": {
      "filePath": "admindashboard/_layout/tutor-feedback.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/users": {
      "filePath": "admindashboard/_layout/users.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/clientdashboard/_layout/engagement_agreement": {
      "filePath": "clientdashboard/_layout/engagement_agreement.lazy.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/clientdashboard/_layout/events": {
      "filePath": "clientdashboard/_layout/events.lazy.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/clientdashboard/_layout/onboard": {
      "filePath": "clientdashboard/_layout/onboard.lazy.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/tutordashboard/_layout/clients": {
      "filePath": "tutordashboard/_layout/clients.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/tutordashboard/_layout/create-booking": {
      "filePath": "tutordashboard/_layout/create-booking.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/tutordashboard/_layout/create-event": {
      "filePath": "tutordashboard/_layout/create-event.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/tutordashboard/_layout/events": {
      "filePath": "tutordashboard/_layout/events.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/tutordashboard/_layout/inquiries": {
      "filePath": "tutordashboard/_layout/inquiries.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/tutordashboard/_layout/profile": {
      "filePath": "tutordashboard/_layout/profile.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/admindashboard/_layout/": {
      "filePath": "admindashboard/_layout/index.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/clientdashboard/_layout/": {
      "filePath": "clientdashboard/_layout/index.lazy.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/tutordashboard/_layout/": {
      "filePath": "tutordashboard/_layout/index.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/clientdashboard/_layout/stripe/checkout": {
      "filePath": "clientdashboard/_layout/stripe.checkout.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/admindashboard/_layout/classes_/$classId": {
      "filePath": "admindashboard/_layout/classes_.$classId.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/classes_/new": {
      "filePath": "admindashboard/_layout/classes_.new.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/events_/$eventId": {
      "filePath": "admindashboard/_layout/events_.$eventId.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/events_/new": {
      "filePath": "admindashboard/_layout/events_.new.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/family/$familyId": {
      "filePath": "admindashboard/_layout/family.$familyId.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/inquiries_/$id": {
      "filePath": "admindashboard/_layout/inquiries_.$id.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/messaging_/new": {
      "filePath": "admindashboard/_layout/messaging_.new.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/staff_/$staffId": {
      "filePath": "admindashboard/_layout/staff_.$staffId.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/staff_/create": {
      "filePath": "admindashboard/_layout/staff_.create.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/transactions_/$transactionId": {
      "filePath": "admindashboard/_layout/transactions_.$transactionId.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/users_/$userId": {
      "filePath": "admindashboard/_layout/users_.$userId.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/clientdashboard/_layout/event/$eventId": {
      "filePath": "clientdashboard/_layout/event.$eventId.lazy.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/clientdashboard/_layout/stripe/cancel": {
      "filePath": "clientdashboard/_layout/stripe.cancel.lazy.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/clientdashboard/_layout/stripe/success": {
      "filePath": "clientdashboard/_layout/stripe.success.lazy.tsx",
      "parent": "/clientdashboard/_layout"
    },
    "/tutordashboard/_layout/events_/$eventId": {
      "filePath": "tutordashboard/_layout/events_.$eventId.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/tutordashboard/_layout/inquiries_/$id": {
      "filePath": "tutordashboard/_layout/inquiries_.$id.lazy.tsx",
      "parent": "/tutordashboard/_layout"
    },
    "/admindashboard/_layout/classes_/$classId_/edit": {
      "filePath": "admindashboard/_layout/classes_.$classId_.edit.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/events_/$eventId_/charge": {
      "filePath": "admindashboard/_layout/events_.$eventId_.charge.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/events_/$eventId_/edit": {
      "filePath": "admindashboard/_layout/events_.$eventId_.edit.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/family/$familyId_/edit": {
      "filePath": "admindashboard/_layout/family.$familyId_.edit.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/inquiries_/$id_/edit": {
      "filePath": "admindashboard/_layout/inquiries_.$id_.edit.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/messaging_/$ruleId/edit": {
      "filePath": "admindashboard/_layout/messaging_.$ruleId.edit.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/staff_/$staffId_/edit": {
      "filePath": "admindashboard/_layout/staff_.$staffId_.edit.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/transactions_/$transactionId_/edit": {
      "filePath": "admindashboard/_layout/transactions_.$transactionId_.edit.lazy.tsx",
      "parent": "/admindashboard/_layout"
    },
    "/admindashboard/_layout/users_/$userId_/edit": {
      "filePath": "admindashboard/_layout/users_.$userId_.edit.lazy.tsx",
      "parent": "/admindashboard/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
